<template>
  <v-card class="pa-6">
    <!-- <v-card-title class="text-h5 font-weight-bold pa-0 mb-4">
      {{ assistantData ? "ویرایش دستیار شخصی سازی شده" : "ساخت دستیار شخصی سازی شده" }}
      
      <div>-->
    <!-- Desktop Version -->
    <!-- <personal-assistant-builder-mobile
      v-if="$vuetify.breakpoint.mobile"
      :form-data="formData"
      :assistant-data="assistantData"
      :assistant-types="assistantTypes"
      :product-service-types="productServiceTypes"
      :main-industries="mainIndustries"
      :organization-types="organizationTypes"
      :product-service-type-details="productServiceTypeDetails"
      :brand-specs="brandSpecs"
      :reference-styles="referenceStyles"
      :sales-goals="salesGoals"
      :support-goals="supportGoals"
      :engagement-goals="engagementGoals"
      :tones="tones"
      :personalities="personalities"
      :response-lengths="responseLengths"
      :preferred-structures="preferredStructures"
      :information-sources="informationSources"
      :no-information-behaviors="noInformationBehaviors"
      :content-sensitivities="contentSensitivities"
      :claim-controls="claimControls"
      :privacy-securities="privacySecurities"
      :general-keywords="generalKeywords"
      :technical-keywords="technicalKeywords"
      :b2b-keywords="b2bKeywords"
      :call-to-action-types="callToActionTypes"
      :goal-priorities="goalPriorities"
      :no-info-behaviors="noInfoBehaviors"
      :quality-controls="qualityControls"
      :emotional-detections="emotionalDetections"
      :emotional-reactions="emotionalReactions"
      :brand-policies="brandPolicies"
      :repeat-question-behaviors="repeatQuestionBehaviors"
      @save="save"
      @cancel="cancel"
      @reset="resetForm"
    /> -->
    <div>
      <!-- Progress Indicator -->
      <v-card class="ma-5" elevation="2">
        <v-card-text class="py-4">
          <div class="text-center mb-2">
            <span class="text-caption text--secondary"
              >پیشرفت تکمیل دستیار شخصی سازی شده</span
            >
          </div>
          <v-progress-linear
            :value="(completedSections / totalSections) * 100"
            color="progressGradient"
            height="8"
            rounded
            :style="{ background: progressBarBackground }"
            class="rainbow-progress"
          />
          <div class="text-center mt-2">
            <span class="text-body-2 font-weight-bold">
              {{ Math.round((completedSections / totalSections) * 100) }}%
            </span>
          </div>
        </v-card-text>
      </v-card>

      <!-- <div class="mb-4 d-flex flex-wrap gap-2">
        <v-chip
          v-if="formData.assistantName"
          class="chip-base"
          close
          color="primary"
          @click:close="clearField('assistantName')"
        >
          نام: {{ formData.assistantName }}
        </v-chip>

        <v-chip
          v-if="formData.assistantType"
          class="chip-base"
          close
          color="deep-purple"
          @click:close="clearField('assistantType')"
        >
          نوع: {{ formData.assistantType }}
        </v-chip>

        <v-chip
          v-if="formData.productServiceType"
          class="chip-base"
          close
          color="indigo"
          @click:close="clearField('productServiceType')"
        >
          محصول/خدمت: {{ formData.productServiceType }}
        </v-chip>
      </div> -->
      <!-- مشخصات پایه دستیار -->
      <v-expansion-panels v-model="panels" accordion class="px-8">
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon left small class="px-2">mdi-robot</v-icon> مشخصات پایه
                دستیار
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('basic')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("basic") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('basic')}`"
                >
                  {{ getSectionStatusText("basic") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
              >
                این بخش هویت کلی دستیار شما را مشخص می‌کند؛ اینکه دستیار چه نقشی
                دارد و درباره چه چیزی صحبت می‌کند.
              </v-alert>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.assistantName"
                  label="نام دستیار *"
                  outlined
                  dense
                  :rules="[rules.required]"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.assistantType"
                  :items="assistantTypes"
                  label="نوع دستیار *"
                  outlined
                  dense
                  clearable
                  :rules="[rules.required]"
                  required
                  @change="onAssistantTypeChange"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.productServiceType"
                  :items="productServiceTypes"
                  label="نوع محصول/خدمت *"
                  outlined
                  dense
                  clearable
                  :rules="[rules.required]"
                  required
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            v-if="formData.selectedMainIndustry"
            close
            color="teal"
            class="chip-industry"
            @click:close="
              formData.selectedMainIndustry = null;
              formData.selectedIndustries = [];
            "
          >
            صنعت اصلی: {{ formData.selectedMainIndustry }}
          </v-chip>
          <v-chip
            v-for="(industry, index) in formData.selectedIndustries"
            :key="industry"
            close
            color="teal"
            class="chip-goal"
            @click:close="
              removeFromArray(formData.selectedIndustries, industry)
            "
          >
            صنعت -{{ index + 1 }}: {{ industry }}
          </v-chip>
        </div> -->
        <!-- صنعت/حوزه فعالیت -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon left small class="px-2">mdi-factory</v-icon>صنعت/حوزه
                فعالیت
              </div>
              <!-- <div class="d-flex align-center"> -->
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('industry')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("industry") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('industry')}`"
                >
                  {{ getSectionStatusText("industry") }}
                </span>
              </div>
              <!-- <v-btn
                  v-if="!isSectionSkipped('industry')"
                  icon
                  small
                  color="grey"
                  @click.stop="skipSection('industry')"
                  class="mr-2"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  icon
                  small
                  color="success"
                  @click.stop="unskipSection('industry')"
                  class="mr-2"
                >
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
              </div> -->
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >با انتخاب صنعت، دستیار از اصطلاحات و مثال‌های متناسب با
                کسب‌وکار شما استفاده می‌کند. می‌توانید چند صنعت انتخاب کنید اگر
                کسب‌وکار شما چندحوزه‌ای است.
              </v-alert>

              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="selectedMainIndustry"
                  :items="mainIndustries"
                  item-text="name"
                  item-value="id"
                  label="انتخاب صنعت اصلی"
                  outlined
                  dense
                  clearable
                  @click:close="
                    formData.selectedMainIndustry = null;
                    formData.selectedIndustries = [];
                  "
                />
              </v-col>
              <v-col cols="12" md="6" v-if="selectedMainIndustry">
                <v-autocomplete
                  v-model="formData.selectedIndustries"
                  :items="availableSubIndustries"
                  label="انتخاب زیر صنایع (حداکثر ۵ مورد)"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :max="5"
                  :rules="[rules.maxFive]"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="removeIndustry(item)"
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            v-if="formData.organizationType"
            close
            color="blue-grey"
            class="chip-product"
            @click:close="clearField('organizationType')"
          >
            سازمان: {{ formData.organizationType }}
          </v-chip>
          <v-chip
            v-if="formData.productServiceTypeDetail"
            close
            color="cyan"
            class="chip-product"
            @click:close="clearField('productServiceTypeDetail')"
          >
            جزئیات محصول: {{ formData.productServiceTypeDetail }}
          </v-chip>
          <v-chip
            v-if="formData.brandSpec"
            close
            color="pink"
            class="chip-product"
            @click:close="clearField('brandSpec')"
          >
            برند: {{ formData.brandSpec }}
          </v-chip>
          <v-chip
            v-if="formData.referenceStyle"
            close
            color="purple"
            class="chip-product"
            @click:close="clearField('referenceStyle')"
          >
            اشاره: {{ formData.referenceStyle }}
          </v-chip>
        </div> -->
        <!-- مشخصات محصول / خدمت -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon left small class="px-2">mdi-package-variant</v-icon
                >مشخصات محصول / خدمت
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('product')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("product") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('product')}`"
                >
                  {{ getSectionStatusText("product") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
              >
                دقیقاً چه نوع سازمان، محصول یا خدمتی هستید، چه سطح قیمتی و
                تصویری از برند دارید و در پاسخ‌ها چگونه به محصول، برند و سازمان
                اشاره کند.
              </v-alert>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.organizationType"
                  :items="organizationTypes"
                  label="مشخصات مجموعه / سازمان"
                  outlined
                  dense
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.productServiceTypeDetail"
                  :items="productServiceTypeDetails"
                  label="نوع محصول / خدمت"
                  outlined
                  dense
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.brandSpec"
                  :items="brandSpecs"
                  label="مشخصات برند"
                  outlined
                  dense
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.referenceStyle"
                  :items="referenceStyles"
                  label="نحوه اشاره در پاسخ"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            v-for="(goal, index) in formData.salesGoals"
            :key="goal"
            close
            color="green"
            class="chip-goals"
            @click:close="removeFromArray(formData.salesGoals, goal)"
          >
            فروش -{{ index + 1 }}: {{ goal }}
          </v-chip>
          <v-chip
            v-for="(goal, index) in formData.supportGoals"
            :key="goal"
            close
            color="amber"
            class="chip-goals"
            @click:close="removeFromArray(formData.supportGoals, goal)"
          >
            پشتیبانی -{{ index + 1 }}: {{ goal }}
          </v-chip>
          <v-chip
            v-for="(goal, index) in formData.engagementGoals"
            :key="goal"
            close
            color="orange"
            class="chip-goals"
            @click:close="removeFromArray(formData.engagementGoals, goal)"
          >
            جذب -{{ index + 1 }}: {{ goal }}
          </v-chip>
        </div> -->
        <!-- هدف دستیار -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon left small class="px-2">mdi-target</v-icon>هدف دستیار
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('goals')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("goals") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('goals')}`"
                >
                  {{ getSectionStatusText("goals") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
              >
                این بخش مشخص می‌کند دستیار بیشتر روی فروش، پشتیبانی یا راهنمایی
                کاربر تمرکز داشته باشد. انتخاب چند هدف باعث می‌شود دستیار رفتار
                متعادل‌تری داشته باشد.
              </v-alert>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.salesGoals"
                  :items="salesGoals"
                  label="فروش و تبدیل"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="removeFromArray(formData.salesGoals, item)"
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.supportGoals"
                  :items="supportGoals"
                  label="پشتیبانی و عملیات"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.supportGoals, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.engagementGoals"
                  :items="engagementGoals"
                  label="جذب و ارتباط"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.engagementGoals, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            v-if="formData.tone"
            close
            color="deep-orange"
            class="chip-tone"
            @click:close="clearField('tone')"
          >
            لحن: {{ formData.tone }}
          </v-chip>

          <v-chip
            v-if="formData.personality"
            close
            color="brown"
            class="chip-tone"
            @click:close="clearField('personality')"
          >
            شخصیت: {{ formData.personality }}
          </v-chip> -->
        <!-- پیام وقتی هیچ چیپی نیست -->
        <!--<span v-if="!hasAnyChip" class="text--secondary grey--text">
            هیچ تنظیماتی انتخاب نشده است.
          </span>-->
        <!-- </div> -->

        <!-- لحن و شخصیت پاسخ گویی -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon left small class="px-2">mdi-comment-text-outline</v-icon
                >لحن و شخصیت پاسخ گویی
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('tone')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("tone") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('tone')}`"
                >
                  {{ getSectionStatusText("tone") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >این بخش لحن و شخصیت را تعیین می‌کند که دستیار چگونه صحبت کند و
                چقدر رسمی یا دوستانه باشد. تا با برند و مخاطب شما هماهنگ باشد.
              </v-alert>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.tone"
                  :items="tones"
                  label="لحن کلی"
                  outlined
                  dense
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.personality"
                  :items="personalities"
                  label="شخصیت دستیار"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            v-if="formData.responseLength"
            close
            class="chip-structure"
            color="lime"
            @click:close="clearField('responseLength')"
          >
            طول پاسخ: {{ formData.responseLength }}
          </v-chip>

          <v-chip
            v-if="formData.preferredStructure"
            close
            color="light-green"
            class="chip-structure"
            @click:close="clearField('preferredStructure')"
          >
            ساختار: {{ formData.preferredStructure }}
          </v-chip>
        </div> -->

        <!-- ساختار پاسخ ها -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon left small class="px-2">mdi-format-list-bulleted</v-icon
                >ساختار پاسخ ها
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('structure')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("structure") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('structure')}`"
                >
                  {{ getSectionStatusText("structure") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >این بخش میزان خلاصه یا مفصل بودن پاسخ‌ها و نحوه نمایش آن‌ها را
                تعیین می‌کند. مشخص می‌کند پاسخ‌ها مرحله ای، کوتاه، متوسط یا
                کاملاً توضیحی باشند.
              </v-alert>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.responseLength"
                  :items="responseLengths"
                  label="طول پاسخ"
                  outlined
                  dense
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.preferredStructure"
                  :items="preferredStructures"
                  label="ساختار ترجیحی"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-info"
            v-if="formData.informationSource"
            close
            color="red"
            @click:close="clearField('informationSource')"
          >
            منبع اطلاعات: {{ formData.informationSource }}
          </v-chip>

          <v-chip
            class="chip-info"
            v-if="formData.noInformationBehavior"
            close
            color="red"
            @click:close="clearField('noInformationBehavior')"
          >
            عدم وجود اطلاعات دقیق: {{ formData.noInformationBehavior }}
          </v-chip>
        </div> -->

        <!-- سطح مجاز اطلاعات -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon left small class="px-2">mdi-information</v-icon>سطح مجاز
                اطلاعات
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('information')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("information") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('information')}`"
                >
                  {{ getSectionStatusText("information") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >این بخش تعیین می‌کند دستیار از چه سطح اطلاعاتی استفاده کند و در
                نبود داده دقیق چگونه رفتار کند. دستیار فقط از اطلاعات شما یا از
                توصیه‌های عمومی ایمن هم استفاده کند.
              </v-alert>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.informationSource"
                  :items="informationSources"
                  label="منبع اطلاعات"
                  outlined
                  dense
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.noInformationBehavior"
                  :items="noInformationBehaviors"
                  label="عدم وجود اطلاعات دقیق"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-restrictions"
            v-for="(sensitivity, index) in formData.contentSensitivity"
            :key="sensitivity"
            close
            color="green"
            @click:close="
              removeFromArray(formData.contentSensitivity, sensitivity)
            "
          >
            حساسیت محتوا -{{ index + 1 }}: {{ sensitivity }}
          </v-chip>
          <v-chip
            class="chip-restrictions"
            v-for="(control, index) in formData.claimControl"
            :key="control"
            close
            color="blue"
            @click:close="removeFromArray(formData.claimControl, control)"
            >کنترل ادعا -{{ index + 1 }}: {{ control }}</v-chip
          >
          <v-chip
            class="chip-restrictions"
            v-for="(privacy, index) in formData.privacySecurity"
            :key="privacy"
            close
            color="purple"
            @click:close="removeFromArray(formData.privacySecurity, privacy)"
            >حریم خصوصی و امنیت -{{ index + 1 }}: {{ privacy }}</v-chip
          >
        </div> -->

        <!-- محدودیت ها -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon left small class="px-2">mdi-lock</v-icon>محدودیت ها
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('constraints')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("constraints") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('constraints')}`"
                >
                  {{ getSectionStatusText("constraints") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >موارد این بخش را برای جلوگیری از پاسخ‌های حساس، خطرناک یا
                پرریسک استفاده کنید. پیشنهاد می‌شود این گزینه‌ها را فعال نگه
                دارید تا دستیار ایمن و قابل اعتماد بماند.
              </v-alert>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.contentSensitivity"
                  :items="contentSensitivities"
                  label="حساسیت محتوا"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.contentSensitivity, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('contentSensitivity')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.claimControl"
                  :items="claimControls"
                  label="کنترل ادعا"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.claimControl, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('claimControl')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.privacySecurity"
                  :items="privacySecurities"
                  label="حریم خصوصی و امنیت"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.privacySecurity, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('privacySecurity')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-keywords"
            v-for="(genetalkey, index) in formData.generalKeywords"
            :key="genetalkey"
            close
            color="red"
            @click:close="removeFromArray(formData.generalKeywords, genetalkey)"
          >
            عمومی -{{ index + 1 }}: {{ genetalkey }}
          </v-chip>
          <v-chip
            class="chip-keywords"
            v-for="(technical, index) in formData.technicalKeywords"
            :key="technical"
            close
            color="red"
            @click:close="
              removeFromArray(formData.technicalKeywords, technical)
            "
          >
            فنی -{{ index + 1 }}: {{ technical }}
          </v-chip>
          <v-chip
            class="chip-keywords"
            v-for="(b2b, index) in formData.b2bKeywords"
            :key="b2b"
            close
            color="red"
            @click:close="removeFromArray(formData.b2bKeywords, b2b)"
          >
            B2B -{{ index + 1 }}: {{ b2b }}
          </v-chip>
        </div> -->

        <!-- کلید واژه های مهم -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon small left>mdi-key</v-icon>کلید واژه های مهم
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('keywords')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("keywords") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('keywords')}`"
                >
                  {{ getSectionStatusText("keywords") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
              >
                این بخش مشخص می‌کند دستیار بیشتر روی چه موضوعاتی تمرکز کند.
                انتخاب کلیدواژه‌ها باعث می‌شود پاسخ‌ها دقیق‌تر و کاربردی‌تر
                شوند.
              </v-alert>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.generalKeywords"
                  :items="generalKeywords"
                  label="عمومی"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.generalKeywords, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('generalKeywords')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.technicalKeywords"
                  :items="technicalKeywords"
                  label="محصول فنی"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.technicalKeywords, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('technicalKeywords')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.b2bKeywords"
                  :items="b2bKeywords"
                  label="B2B"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="removeFromArray(formData.b2bKeywords, item)"
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('b2bKeywords')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            v-if="formData.callToActionType"
            close
            class="chip-cta"
            color="red"
            @click:close="clearField('callToActionType')"
          >
            نوع فراخوان : {{ formData.callToActionType }}
          </v-chip>
          <v-chip
            v-if="formData.customCallToAction"
            close
            class="chip-cta"
            color="purple"
            @click:close="clearField('customCallToAction')"
          >
            متن فراخوان دلخواه : {{ formData.customCallToAction }}
          </v-chip> -->
        <!-- پیام وقتی هیچ چیپی نیست -->
        <!--<span v-if="!hasAnyChip" class="text--secondary grey--text">
            هیچ تنظیماتی انتخاب نشده است.
          </span>-->
        <!-- </div> -->
        <!-- نوع فراخوان -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon small left>mdi-hand-pointing-right</v-icon>نوع فراخوان
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('cta')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("cta") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('cta')}`"
                >
                  {{ getSectionStatusText("cta") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >این بخش تعیین می‌کند در پایان پاسخ، دستیار، مشتری را به چه
                اقدامی دعوت کند. یکی از موارد را انتخاب کنید، یا متن مورد نیاز
                خود را وارد کنید.
              </v-alert>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.callToActionType"
                  :items="callToActionTypes"
                  label="نوع فراخوان"
                  outlined
                  dense
                  clearable
                  :custom-filter="customFilter"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                v-if="formData.callToActionType === 'custom'"
              >
                <v-text-field
                  v-model="formData.customCallToAction"
                  label="متن فراخوان دلخواه"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-logic"
            v-for="(goal, index) in formData.goalPriority"
            :key="index"
            close
            color="red"
            @click:close="removeFromArray(formData.goalPriority, goal)"
          >
            اولویت در تعارض هدف -{{ index + 1 }}: {{ goal }}
          </v-chip>
          <v-chip
            class="chip-logic"
            v-for="(behavior, index) in formData.noInfoBehavior"
            :key="index"
            close
            color="gray"
            @click:close="removeFromArray(formData.noInfoBehavior, behavior)"
          >
            رفتار در نبود اطلاعات کافی -{{ index + 1 }}: {{ behavior }}
          </v-chip> -->

        <!-- پیام وقتی هیچ چیپی نیست -->
        <!--<span v-if="!hasAnyChip" class="text--secondary grey--text">
            هیچ تنظیماتی انتخاب نشده است.
          </span>-->
        <!-- </div> -->
        <!-- منطق تصمیم گیری -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon small left>mdi-lightbulb-on</v-icon>منطق تصمیم گیری
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('decision')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("decision") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('decision')}`"
                >
                  {{ getSectionStatusText("decision") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >این بخش مشخص می‌کند وقتی اهداف یا اطلاعات با هم تداخل دارند،
                دستیار چگونه تصمیم بگیرد و سردرگم نشود.
              </v-alert>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.goalPriority"
                  :items="goalPriorities"
                  label="اولویت در تعارض اهداف"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.goalPriority, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('goalPriority')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.noInfoBehavior"
                  :items="noInfoBehaviors"
                  label="رفتار در نبود اطلاعات کافی"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.noInfoBehavior, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('noInfoBehavior')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-quality"
            v-for="(control, index) in formData.qualityControl"
            :key="index"
            close
            color="gray"
            @click:close="removeFromArray(formData.qualityControl, control)"
          >
            کنترل کیفیت -{{ index + 1 }}: {{ control }}
          </v-chip> -->
        <!-- پیام وقتی هیچ چیپی نیست -->
        <!--<span v-if="!hasAnyChip" class="text--secondary grey--text">
            هیچ تنظیماتی انتخاب نشده است.
          </span>-->
        <!-- </div> -->
        <!-- کنترل کیفیت پاسخ ها -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon small left>mdi-check-circle</v-icon>کنترل کیفیت پاسخ ها
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('quality')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("quality") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('quality')}`"
                >
                  {{ getSectionStatusText("quality") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >این بخش تضمین می‌کند پاسخ‌ها دقیق، امن، قابل اعتماد و هم‌راستا
                با برند شما باقی بمانند.
              </v-alert>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.qualityControl"
                  :items="qualityControls"
                  label="کنترل کیفیت"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.qualityControl, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('qualityControl')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-emotion"
            v-for="(emotion, index) in formData.emotionalDetection"
            :key="index"
            close
            color="red"
            @click:close="removeFromArray(formData.emotionalDetection, emotion)"
          >
            نوع تشخیص -{{ index + 1 }}: {{ emotion }}
          </v-chip>
          <v-chip
            class="chip-emotion"
            v-for="(reaction, index) in formData.emotionalReaction"
            :key="index"
            close
            color="red"
            @click:close="removeFromArray(formData.emotionalReaction, reaction)"
          >
            واکنش پیشنهادی -{{ index + 1 }}: {{ reaction }}
          </v-chip> -->
        <!-- پیام وقتی هیچ چیپی نیست -->
        <!--<span v-if="!hasAnyChip" class="text--secondary grey--text">
            هیچ تنظیماتی انتخاب نشده است.
          </span>-->
        <!-- </div> -->
        <!-- تشخیص وضعیت احساسی مشتری -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon small left>mdi-emoticon-happy</v-icon>تشخیص وضعیت احساسی
                مشتری
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('sentiment')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("sentiment") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('sentiment')}`"
                >
                  {{ getSectionStatusText("sentiment") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >این بخش کمک می‌کند دستیار با توجه به حال‌وهوای کاربر، لحن و
                مسیر پاسخ را هوشمندانه تغییر دهد.
              </v-alert>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.emotionalDetection"
                  :items="emotionalDetections"
                  label="نوع تشخیص"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.emotionalDetection, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('emotionalDetection')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.emotionalReaction"
                  :items="emotionalReactions"
                  label="واکنش پیشنهادی"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.emotionalReaction, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('emotionalReaction')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-brand"
            v-for="(brandPolicy, index) in formData.brandPolicy"
            :key="index"
            close
            color="red"
            @click:close="removeFromArray(formData.brandPolicy, brandPolicy)"
          >
            خط مشی و DNA برند -{{ index + 1 }}: {{ brandPolicy }}
          </v-chip>
          <template v-if="formData.bannedWords.trim()">
            <v-chip
              class="chip-brand"
              v-for="(bannedWord, index) in formData.bannedWords
                .split(/[,،]/)
                .map((w) => w.trim())
                .filter((w) => w)"
              :key="index"
              close
              color="red"
              @click:close="removeBannedWord(bannedWord)"
            >
              کلمه ممنوعه -{{ index + 1 }}: {{ bannedWord }}
            </v-chip>
          </template> -->
        <!-- پیام وقتی هیچ چیپی نیست -->
        <!--<span v-if="!hasAnyChip" class="text--secondary grey--text">
            هیچ تنظیماتی انتخاب نشده است.
          </span>-->
        <!-- </div> -->
        <!-- خط مشی و DNA برند -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon small left>mdi-brain</v-icon>خط مشی و DNA برند
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('brand')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("brand") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('brand')}`"
                >
                  {{ getSectionStatusText("brand") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
              >
                این بخش تضمین می‌کند دستیار دقیقاً مطابق شخصیت برند شما صحبت کند
                و از خطوط قرمز برند عبور نکند.
              </v-alert>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.brandPolicy"
                  :items="brandPolicies"
                  label="خط مشی برند"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="removeFromArray(formData.brandPolicy, item)"
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item @click="addCustomOption('brandPolicy')">
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="bannedWordInput"
                  label="لیست کلمات ممنوعه"
                  outlined
                  dense
                  placeholder="کلمه را تایپ کنید و Enter بزنید"
                  hint="هر کلمه را با زدن Enter اضافه کنید"
                  persistent-hint
                  append-icon="mdi-plus"
                  @keydown.enter.prevent="addBannedWord"
                  @click:append="addBannedWord"
                  clearable
                  @click:clear="bannedWordInput = ''"
                />

                <!-- نمایش چیپ‌های کلمات ممنوعه -->
                <div class="mt-3 d-flex flex-wrap gap-2">
                  <v-chip
                    v-for="(word, index) in bannedWordsList"
                    :key="index"
                    close
                    color="red"
                    text-color="white"
                    class="ma-1 chip-brand"
                    @click:close="removeBannedWordByIndex(index)"
                  >
                    {{ word }}
                  </v-chip>

                  <span
                    v-if="bannedWordsList.length === 0"
                    class="text--secondary text-caption"
                  >
                    هیچ کلمه ممنوعه‌ای اضافه نشده است.
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-repeat"
            v-for="behavior in formData.repeatQuestionBehavior"
            :key="behavior"
            close
            color="red"
            @click:close="
              removeFromArray(formData.repeatQuestionBehavior, behavior)
            "
          >
            رفتار در تکرار سوال: {{ behavior }}
          </v-chip> -->
        <!-- پیام وقتی هیچ چیپی نیست -->
        <!--<span v-if="!hasAnyChip" class="text--secondary grey--text">
            هیچ تنظیماتی انتخاب نشده است.
          </span>-->
        <!-- </div> -->
        <!-- رفتار در تکرار سوال -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon small left>mdi-refresh</v-icon>رفتار در تکرار سوال
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('repetition')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("repetition") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('repetition')}`"
                >
                  {{ getSectionStatusText("repetition") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-alert
                border="left"
                color="info"
                colored-border
                elevation="2"
                type="info"
                >این تنظیمات از خسته‌کننده شدن گفتگو جلوگیری می‌کند و تجربه
                کاربری روان‌تری می‌سازد.
              </v-alert>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formData.repeatQuestionBehavior"
                  :items="repeatQuestionBehaviors"
                  label="رفتار در تکرار"
                  outlined
                  dense
                  multiple
                  chips
                  deletable-chips
                  :custom-filter="customFilter"
                >
                  <template v-slot:selection="{ attrs, item, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click:close="
                        removeFromArray(formData.repeatQuestionBehavior, item)
                      "
                      class="ma-1"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-slot:append-item>
                    <v-list-item
                      @click="addCustomOption('repeatQuestionBehavior')"
                    >
                      <v-list-item-content>
                        <v-list-item-title class="text-primary">
                          <v-btn class="btn-add-with-text mx-8 btn-w">
                            <v-icon left small class="px-2">mdi-plus</v-icon>
                            افزودن مورد جدید
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div class="mb-4 d-flex flex-wrap gap-2">
          <v-chip
            class="chip-additional"
            v-if="formData.additionalInfo"
            close
            color="red"
            @click:close="clearField('additionalInfo')"
          >
            اطلاعات تکمیلی اضافه شده
          </v-chip>
        </div> -->
        <!-- اطلاعات تکمیلی -->
        <v-expansion-panel>
          <v-expansion-panel-header class="panel-header">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="text-h6 d-flex align-center">
                <v-icon small left>mdi-note-text</v-icon>اطلاعات تکمیلی
              </div>
              <div class="d-flex align-center mr-4">
                <v-icon
                  :color="getSectionStatusColor('additional')"
                  small
                  class="mr-2"
                >
                  {{ getSectionStatusIcon("additional") }}
                </v-icon>
                <span
                  class="text-caption"
                  :class="`text--${getSectionStatusTextColor('additional')}`"
                >
                  {{ getSectionStatusText("additional") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="panel-content">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="formData.additionalInfo"
                  label="توضیحات"
                  outlined
                  rows="5"
                  hint="هر گونه اطلاعات اضافی که می‌خواهید به دستیار اضافه شود"
                  persistent-hint
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- دکمه‌های عملیاتی -->
      <v-card-actions class="mt-4" v-if="$vuetify.breakpoint.mdAndUp">
        <v-btn class="rounded-lg mb2 btn-delete" outlined @click="cancel">
          انصراف <v-icon left>mdi-cancel</v-icon></v-btn
        >

        <v-spacer />
        <v-btn
          outlined
          class="btn-upload rounded-lg mb2"
          :loading="loading"
          @click="showSummaryDialog = true"
        >
          خلاصه تنظیمات
          <v-icon left>mdi-clipboard-list</v-icon>
        </v-btn>
        <v-btn class="rounded-lg mb2 btn-edit" outlined @click="refreshForm">
          بازنشانی دستیار <v-icon left>mdi-refresh</v-icon></v-btn
        >

        <v-btn
          class="rounded-lg mb2 btn-get-code"
          :loading="loading"
          :disabled="loading"
          @click="save"
        >
          {{ assistantData ? "به‌روزرسانی دستیار" : "ساخت دستیار" }}
          <v-icon left>mdi-robot</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions class="mt-4 dcolumn" v-else>
        <v-spacer />
        <v-btn
          outlined
          class="btn-upload rounded-lg mb2 w-100"
          :loading="loading"
          @click="showSummaryDialog = true"
        >
          خلاصه تنظیمات
          <v-icon left>mdi-clipboard-list</v-icon>
        </v-btn>
        <v-btn
          class="rounded-lg mb2 btn-edit w-100"
          outlined
          @click="refreshForm"
        >
          بازنشانی دستیار <v-icon left>mdi-refresh</v-icon></v-btn
        >
        <v-btn
          class="rounded-lg mb2 btn-get-code w-100"
          :loading="loading"
          @click="save"
        >
          {{ assistantData ? "به‌روزرسانی دستیار" : "ساخت دستیار" }}
          <v-icon left>mdi-robot</v-icon>
        </v-btn>
        <v-btn class="rounded-lg mb2 btn-delete w-100" outlined @click="cancel">
          انصراف <v-icon left>mdi-cancel</v-icon></v-btn
        >
      </v-card-actions>

      <!-- Dialog خلاصه تنظیمات -->
      <custom-popup
        v-model="showSummaryDialog"
        :cons="{ title: 'خلاصه تنظیمات دستیار', icon: 'clipboard-list' }"
        @close="showSummaryDialog = false"
        max-width="900"
        scrollable
        hide-confirm
        hide-overlay
      >
        <v-card>
          <v-card-text class="pa-4">
            <!-- مشخصات پایه -->
            <v-card
              outlined
              class="mb-4"
              style="border-right: 4px solid #3b82f6"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #3b82f6"
              >
                <v-icon left small>mdi-robot</v-icon>
                مشخصات پایه
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-if="formData.assistantName"
                    class="ma-1 chip-base"
                    close
                    @click:close="clearField('assistantName')"
                  >
                    نام: {{ formData.assistantName }}
                  </v-chip>
                  <v-chip
                    v-if="formData.assistantType"
                    class="ma-1 chip-base"
                    close
                    @click:close="clearField('assistantType')"
                  >
                    نوع: {{ formData.assistantType }}
                  </v-chip>
                  <v-chip
                    v-if="formData.productServiceType"
                    class="ma-1 chip-base"
                    close
                    @click:close="clearField('productServiceType')"
                  >
                    محصول/خدمت: {{ formData.productServiceType }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- صنعت -->
            <v-card
              v-if="
                formData.selectedIndustries?.length > 0 ||
                formData.selectedMainIndustry
              "
              outlined
              class="mb-4"
              style="border-right: 4px solid #10b981"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #10b981"
              >
                <v-icon left small>mdi-factory</v-icon>
                صنعت/حوزه فعالیت
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-if="formData.selectedMainIndustry"
                    class="ma-1 chip-industry"
                    close
                    @click:close="
                      formData.selectedMainIndustry = null;
                      formData.selectedIndustries = [];
                    "
                  >
                    صنعت اصلی: {{ formData.selectedMainIndustry }}
                  </v-chip>
                  <v-chip
                    v-for="(industry, index) in formData.selectedIndustries"
                    :key="index"
                    class="ma-1 chip-industry"
                    close
                    @click:close="
                      removeFromArray(formData.selectedIndustries, industry)
                    "
                  >
                    {{ industry }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- مشخصات محصول -->
            <v-card
              v-if="
                formData.organizationType ||
                formData.brandSpec ||
                formData.referenceStyle
              "
              outlined
              class="mb-4"
              style="border-right: 4px solid #6366f1"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #6366f1"
              >
                <v-icon left small>mdi-package-variant</v-icon>
                مشخصات محصول/خدمت
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-if="formData.organizationType"
                    class="ma-1 chip-product"
                    close
                    @click:close="clearField('organizationType')"
                  >
                    سازمان: {{ formData.organizationType }}
                  </v-chip>
                  <v-chip
                    v-if="formData.brandSpec"
                    class="ma-1 chip-product"
                    close
                    @click:close="clearField('brandSpec')"
                  >
                    برند: {{ formData.brandSpec }}
                  </v-chip>
                  <v-chip
                    v-if="formData.referenceStyle"
                    class="ma-1 chip-product"
                    close
                    @click:close="clearField('referenceStyle')"
                  >
                    اشاره: {{ formData.referenceStyle }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- اهداف -->
            <v-card
              v-if="
                formData.salesGoals?.length > 0 ||
                formData.supportGoals?.length > 0 ||
                formData.engagementGoals?.length > 0
              "
              outlined
              class="mb-4"
              style="border-right: 4px solid #f59e0b"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #f59e0b"
              >
                <v-icon left small>mdi-target</v-icon>
                هدف دستیار
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(goal, index) in formData.salesGoals"
                    :key="'sales-' + index"
                    class="ma-1 chip-goals"
                    close
                    @click:close="removeFromArray(formData.salesGoals, goal)"
                  >
                    فروش: {{ goal }}
                  </v-chip>
                  <v-chip
                    v-for="(goal, index) in formData.supportGoals"
                    :key="'support-' + index"
                    class="ma-1 chip-goals"
                    close
                    @click:close="removeFromArray(formData.supportGoals, goal)"
                  >
                    پشتیبانی: {{ goal }}
                  </v-chip>
                  <v-chip
                    v-for="(goal, index) in formData.engagementGoals"
                    :key="'engagement-' + index"
                    class="ma-1 chip-goals"
                    close
                    @click:close="
                      removeFromArray(formData.engagementGoals, goal)
                    "
                  >
                    جذب: {{ goal }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- لحن و شخصیت -->
            <v-card
              v-if="formData.tone || formData.personality"
              outlined
              class="mb-4"
              style="border-right: 4px solid #ec4899"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #ec4899"
              >
                <v-icon left small>mdi-comment-text-outline</v-icon>
                لحن و شخصیت
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-if="formData.tone"
                    class="ma-1 chip-tone"
                    close
                    @click:close="clearField('tone')"
                  >
                    لحن: {{ formData.tone }}
                  </v-chip>
                  <v-chip
                    v-if="formData.personality"
                    class="ma-1 chip-tone"
                    close
                    @click:close="clearField('personality')"
                  >
                    شخصیت: {{ formData.personality }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- ساختار پاسخ -->
            <v-card
              v-if="formData.responseLength || formData.preferredStructure"
              outlined
              class="mb-4"
              style="border-right: 4px solid #84cc16"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #84cc16"
              >
                <v-icon left small>mdi-format-list-bulleted</v-icon>
                ساختار پاسخ
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-if="formData.responseLength"
                    class="ma-1 chip-structure"
                    close
                    @click:close="clearField('responseLength')"
                  >
                    طول: {{ formData.responseLength }}
                  </v-chip>
                  <v-chip
                    v-if="formData.preferredStructure"
                    class="ma-1 chip-structure"
                    close
                    @click:close="clearField('preferredStructure')"
                  >
                    ساختار: {{ formData.preferredStructure }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- سطح اطلاعات -->
            <v-card
              v-if="
                formData.informationSource || formData.noInformationBehavior
              "
              outlined
              class="mb-4"
              style="border-right: 4px solid #06b6d4"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #06b6d4"
              >
                <v-icon left small>mdi-information</v-icon>
                سطح اطلاعات
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-if="formData.informationSource"
                    class="ma-1 chip-info"
                    close
                    @click:close="clearField('informationSource')"
                  >
                    منبع: {{ formData.informationSource }}
                  </v-chip>
                  <v-chip
                    v-if="formData.noInformationBehavior"
                    class="ma-1 chip-info"
                    close
                    @click:close="clearField('noInformationBehavior')"
                  >
                    عدم اطلاعات: {{ formData.noInformationBehavior }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- محدودیت‌ها -->
            <v-card
              v-if="
                formData.contentSensitivity?.length > 0 ||
                formData.claimControl?.length > 0 ||
                formData.privacySecurity?.length > 0
              "
              outlined
              class="mb-4"
              style="border-right: 4px solid #ef4444"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #ef4444"
              >
                <v-icon left small>mdi-lock</v-icon>
                محدودیت‌ها
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(item, index) in formData.contentSensitivity"
                    :key="'sensitivity-' + index"
                    class="ma-1 chip-restrictions"
                    close
                    @click:close="
                      removeFromArray(formData.contentSensitivity, item)
                    "
                  >
                    {{ item }}
                  </v-chip>
                  <v-chip
                    v-for="(item, index) in formData.claimControl"
                    :key="'claim-' + index"
                    class="ma-1 chip-restrictions"
                    close
                    @click:close="removeFromArray(formData.claimControl, item)"
                  >
                    {{ item }}
                  </v-chip>
                  <v-chip
                    v-for="(item, index) in formData.privacySecurity"
                    :key="'privacy-' + index"
                    class="ma-1 chip-restrictions"
                    close
                    @click:close="
                      removeFromArray(formData.privacySecurity, item)
                    "
                  >
                    {{ item }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- کلیدواژه‌ها -->
            <v-card
              v-if="
                formData.generalKeywords?.length > 0 ||
                formData.technicalKeywords?.length > 0 ||
                formData.b2bKeywords?.length > 0
              "
              outlined
              class="mb-4"
              style="border-right: 4px solid #8b5cf6"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #8b5cf6"
              >
                <v-icon left small>mdi-key</v-icon>
                کلیدواژه‌ها
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(keyword, index) in formData.generalKeywords"
                    :key="'general-' + index"
                    class="ma-1 chip-keywords"
                    close
                    @click:close="
                      removeFromArray(formData.generalKeywords, keyword)
                    "
                  >
                    عمومی: {{ keyword }}
                  </v-chip>
                  <v-chip
                    v-for="(keyword, index) in formData.technicalKeywords"
                    :key="'technical-' + index"
                    class="ma-1 chip-keywords"
                    close
                    @click:close="
                      removeFromArray(formData.technicalKeywords, keyword)
                    "
                  >
                    فنی: {{ keyword }}
                  </v-chip>
                  <v-chip
                    v-for="(keyword, index) in formData.b2bKeywords"
                    :key="'b2b-' + index"
                    class="ma-1 chip-keywords"
                    close
                    @click:close="
                      removeFromArray(formData.b2bKeywords, keyword)
                    "
                  >
                    B2B: {{ keyword }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- CTA -->
            <v-card
              v-if="formData.callToActionType || formData.customCallToAction"
              outlined
              class="mb-4"
              style="border-right: 4px solid #a855f7"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #a855f7"
              >
                <v-icon left small>mdi-hand-pointing-right</v-icon>
                نوع فراخوان
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-if="formData.callToActionType"
                    class="ma-1 chip-cta"
                    close
                    @click:close="clearField('callToActionType')"
                  >
                    {{
                      formData.callToActionType === "custom"
                        ? formData.customCallToAction
                        : formData.callToActionType
                    }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- منطق تصمیم‌گیری -->
            <v-card
              v-if="
                formData.goalPriority?.length > 0 ||
                formData.noInfoBehavior?.length > 0
              "
              outlined
              class="mb-4"
              style="border-right: 4px solid #f97316"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #f97316"
              >
                <v-icon left small>mdi-lightbulb-on</v-icon>
                منطق تصمیم‌گیری
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(item, index) in formData.goalPriority"
                    :key="'goal-' + index"
                    class="ma-1 chip-logic"
                    close
                    @click:close="removeFromArray(formData.goalPriority, item)"
                  >
                    {{ item }}
                  </v-chip>
                  <v-chip
                    v-for="(item, index) in formData.noInfoBehavior"
                    :key="'noinfo-' + index"
                    class="ma-1 chip-logic"
                    close
                    @click:close="
                      removeFromArray(formData.noInfoBehavior, item)
                    "
                  >
                    {{ item }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- کنترل کیفیت -->
            <v-card
              v-if="formData.qualityControl?.length > 0"
              outlined
              class="mb-4"
              style="border-right: 4px solid #3b82f6"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #3b82f6"
              >
                <v-icon left small>mdi-check-circle</v-icon>
                کنترل کیفیت
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(item, index) in formData.qualityControl"
                    :key="'quality-' + index"
                    class="ma-1 chip-quality"
                    close
                    @click:close="
                      removeFromArray(formData.qualityControl, item)
                    "
                  >
                    {{ item }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- تحلیل احساسی -->
            <v-card
              v-if="
                formData.emotionalDetection?.length > 0 ||
                formData.emotionalReaction?.length > 0
              "
              outlined
              class="mb-4"
              style="border-right: 4px solid #ec4899"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #ec4899"
              >
                <v-icon left small>mdi-emoticon-happy</v-icon>
                تحلیل احساسی
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(item, index) in formData.emotionalDetection"
                    :key="'detection-' + index"
                    class="ma-1 chip-emotion"
                    close
                    @click:close="
                      removeFromArray(formData.emotionalDetection, item)
                    "
                  >
                    تشخیص: {{ item }}
                  </v-chip>
                  <v-chip
                    v-for="(item, index) in formData.emotionalReaction"
                    :key="'reaction-' + index"
                    class="ma-1 chip-emotion"
                    close
                    @click:close="
                      removeFromArray(formData.emotionalReaction, item)
                    "
                  >
                    واکنش: {{ item }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- خط مشی برند -->
            <v-card
              v-if="formData.brandPolicy?.length > 0 || formData.bannedWords"
              outlined
              class="mb-4"
              style="border-right: 4px solid #dc2626"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #dc2626"
              >
                <v-icon left small>mdi-brain</v-icon>
                خط مشی برند
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(item, index) in formData.brandPolicy"
                    :key="'policy-' + index"
                    class="ma-1 chip-brand"
                    close
                    @click:close="removeFromArray(formData.brandPolicy, item)"
                  >
                    {{ item }}
                  </v-chip>
                  <v-chip
                    v-for="(word, index) in bannedWordsList
                      .map((w) => w.trim())
                      .filter((w) => w) || []"
                    :key="'banned-' + index"
                    class="ma-1 chip-brand"
                    close
                    @click:close="removeBannedWord(word)"
                  >
                    ممنوعه: {{ word }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- رفتار در تکرار -->
            <v-card
              v-if="formData.repeatQuestionBehavior?.length > 0"
              outlined
              class="mb-4"
              style="border-right: 4px solid #84cc16"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #84cc16"
              >
                <v-icon left small>mdi-refresh</v-icon>
                رفتار در تکرار
              </v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(item, index) in formData.repeatQuestionBehavior"
                    :key="'repeat-' + index"
                    class="ma-1 chip-repeat"
                    close
                    @click:close="
                      removeFromArray(formData.repeatQuestionBehavior, item)
                    "
                  >
                    {{ item }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>

            <!-- اطلاعات تکمیلی -->
            <v-card
              v-if="formData.additionalInfo"
              outlined
              class="mb-4"
              style="border-right: 4px solid #6b7280"
            >
              <v-card-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #6b7280"
              >
                <v-icon left small>mdi-note-text</v-icon>
                اطلاعات تکمیلی
              </v-card-title>
              <v-card-text>
                <div class="text-body-2">{{ formData.additionalInfo }}</div>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-divider />
        </v-card>
      </custom-popup>
      <!-- دیالوگ افزودن مورد جدید -->
      <custom-popup
        v-model="showAddCustomDialog"
        :cons="{ title: 'افزودن مورد جدید' }"
        @close="showAddCustomDialog = false"
        max-width="500"
      >
        <v-card>
          <v-card-text>
            <v-text-field
              v-model="customOptionText"
              label="متن مورد جدید"
              outlined
              dense
              autofocus
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="showAddCustomDialog = false"
              class="btn-delete rounded-lg"
              >لغو</v-btn
            >
            <v-btn
              @click="addCustomOptionConfirm"
              :disabled="isAddingCustomOption || !customOptionText.trim()"
              :loading="isAddingCustomOption"
              class="btn-get-code rounded-lg"
              >افزودن</v-btn
            >
          </v-card-actions>
        </v-card>
      </custom-popup>
    </div>
  </v-card>
</template>

<script>
import PersonalAssistantBuilderMobile from "./personalAssistantBuilderMobile.vue";

export default {
  name: "personalAssistantBuilder",
  props: {
    assistantData: {
      type: Object,
      default: null,
    },
  },
  components: {
    PersonalAssistantBuilderMobile,
  },
  data() {
    return {
      bannedWordInput: "",
      skippedSections: [],
      showSummaryDialog: false,
      mappings: {
        // === مشخصات پایه ===
        assistantType: {
          "دستیار فروش": "sales_assistant",
          "دستیار پشتیبانی": "support_assistant",
          "دستیار راهنما": "guide_assistant",
          "دستیار مشاور": "consultant_assistant",
          "دستیار اختصاصی برند": "brand_dedicated_assistant",
          "دستیار پاسخ‌گوی واتساپ/دایرکت": "social_media_assistant",
          "دستیار پاسخ‌گوی سایت": "website_chat_assistant",
          "دستیار پاسخ‌گوی تلفنی": "phone_assistant",
          "دستیار آموزش محصول": "product_training_assistant",
          "دستیار پیگیری سفارش": "order_tracking_assistant",
          "دستیار قبل از خرید": "pre_sales_assistant",
          "دستیار بعد از خرید": "post_sales_assistant",
          "دستیار سازمانی (B2B)": "b2b_assistant",
          "دستیار نمایندگی‌ها": "dealer_assistant",
          "دستیار خدمات پس از فروش": "after_sales_assistant",
          "دستیار ثبت شکایت و بازخورد": "complaint_feedback_assistant",
          "دستیار محتوای محصول (FAQ ساز)": "faq_assistant",
          "دستیار مقایسه و انتخاب محصول": "product_comparison_assistant",
        },

        productServiceType: {
          "محصول فیزیکی (کالای مصرفی)": "consumer_physical_product",
          "محصول فیزیکی (کالای بادوام)": "durable_physical_product",
          "خدمت حضوری": "in_person_service",
          "خدمت آنلاین": "online_service",
          "نرم‌افزار / اپلیکیشن (B2C)": "b2c_software_app",
          "نرم‌افزار / SaaS (B2B)": "b2b_saas",
          "پلتفرم / مارکت‌پلیس": "platform_marketplace",
          "اشتراک / عضویت": "subscription_membership",
          "دوره آموزشی / محتوا": "educational_content",
          "سرویس مالی (غیرمشاوره‌ای)": "financial_service_non_advisory",
          "سرویس سلامت عمومی (غیرپزشکی)": "general_health_service",
          "رسانه / سرگرمی / محتوا": "media_entertainment",
          "رویداد / همایش / ورکشاپ": "event_workshop",
          "سازمان / برند چندمحصولی": "multi_product_brand",
        },

        // === صنعت ===
        industryMain: {
          "صنایع مصرفی و فیزیکی": "consumer_physical",
          "دیجیتال و فناوری": "digital_tech",
          "خدمات و B2B": "services_b2b",
          "آموزش و دوره آموزشی": "education_training",
          "سلامت و سبک زندگی": "health_lifestyle",
          "رسانه، فرهنگ، آموزش و محتوا": "media_culture_content",
        },

        industrySub: {},

        // === مشخصات محصول/خدمت ===
        organizationType: {
          "تولید کننده": "manufacturer",
          "توزیع کننده": "distributor",
          فروشگاه: "retailer",
          استارتاپ: "startup",
          "شرکت خدماتی": "service_company",
          "سازمان B2B": "b2b_organization",
          نمایندگی: "dealership",
        },

        brandSpec: {
          اقتصادی: "economy",
          "میان رده": "mid_range",
          پریمیوم: "premium",
          لوکس: "luxury",
          "سازمانی / شرکتی": "corporate",
          "نوآور / استارتاپی": "innovative_startup",
        },

        referenceStyle: {
          "فقط نام محصول": "product_name_only",
          "محصول + برند": "product_and_brand",
          "برند + سازمان": "brand_and_company",
          "محصول + برند + سازمان": "product_brand_and_company",
        },

        // === لحن و شخصیت ===
        tone: {
          "کاملاً رسمی": "very_formal",
          "رسمی و حرفه‌ای": "formal_professional",
          نیمه‌رسمی: "semi_formal",
          دوستانه: "friendly",
          صمیمی: "warm_intimate",
          "لوکس و پریمیوم": "luxury_premium",
          "جوان‌پسند و پرانرژی": "youthful_energetic",
          "مینیمال و خیلی کوتاه": "minimal_very_short",
          "تبلیغاتی (اما بدون اغراق)": "promotional_no_exaggeration",
          مشاوره‌ای: "consultative",
          "فنی/مهندسی": "technical_engineering",
          "آموزشی/مدرس‌گونه": "educational",
          "همدلانه (پشتیبانی‌محور)": "empathetic_support",
        },

        personality: {
          "دقیق و فنی": "precise_technical",
          "ساده و قابل‌فهم": "simple_understandable",
          متقاعدکننده: "persuasive",
          نتیجه‌محور: "results_oriented",
          "سوال‌محور (با پرسش‌های کوتاه)": "question_based",
          "حرفه‌ای و خونسرد": "professional_calm",
          "گرم و صمیمی": "warm_friendly",
          "سخت‌گیر در اطلاعات (بدون حدس)": "strict_no_guessing",
          "داستان‌گو (برای بازاریابی)": "storyteller_marketing",
          "مقایسه‌گر منطقی": "logical_comparer",
        },

        // === ساختار پاسخ ===
        responseLength: {
          "خیلی کوتاه (۱–۲ جمله)": "very_short",
          "کوتاه (۲–۴ جمله)": "short",
          "متوسط (۴–۶ جمله)": "medium",
          "کامل (۷–۱۲ جمله)": "detailed",
          "توضیحی (پاراگرافی)": "explanatory",
          "راهنمای مرحله‌ای": "step_by_step",
          "FAQ سبک (سؤال/جواب کوتاه)": "faq_style",
          چک‌لیست‌محور: "checklist",
          "جدول‌محور (اگر لازم شد)": "table_if_needed",
        },

        preferredStructure: {
          "متن ساده": "plain_text",
          بولت‌پوینت: "bullet_points",
          "مراحل شماره‌دار": "numbered_steps",
          ترکیبی: "combined",
          "سؤال‌های کوتاه برای تکمیل اطلاعات": "clarifying_questions",
          "خلاصه + جزئیات (ابتدا TL;DR)": "summary_first",
        },

        // === سطح اطلاعات ===
        informationSource: {
          "فقط اطلاعاتی که کاربر می‌دهد": "user_provided_only",
          "اطلاعات کاربر + توصیه‌های عمومی ایمن": "user_plus_safe_general",
          "اطلاعات عمومی صنعت (غیرتخصصی)": "general_industry_info",
          "کاتالوگ/FAQ داخلی (اگر داده دادند)": "internal_catalog_faq",
          "بدون حدس و فرض (سخت‌گیر)": "strict_no_assumptions",
          "اطلاعات کاربر + مقایسه کلی بازار (بدون نام برند)":
            "user_plus_general_market_comparison",
        },

        noInformationBehavior: {
          "اعلام عدم‌اطلاعی": "declare_unknown",
          "درخواست اطلاعات بیشتر (عکس/لینک/برچسب)": "ask_for_more_info",
          "ارائه راهنمای کلی": "provide_general_guidance",
          "پیشنهاد مسیر جایگزین (تماس/تیکت)": "suggest_alternative_contact",
          "ترکیب موارد بالا": "combined_approaches",
          "ارائه چند سناریوی محتمل (با برچسب فرضیگ)":
            "possible_scenarios_labeled",
        },

        // === فراخوان به عمل ===
        callToAction: {
          "دعوت به خرید": "invite_to_purchase",
          "درخواست اطلاعات بیشتر": "request_more_info",
          "هدایت به لینک": "direct_to_link",
          "تماس با پشتیبانی": "contact_support",
          ثبت‌نام: "sign_up",
          "رزرو وقت/نوبت": "book_appointment",
          "دریافت کاتالوگ/دمو": "request_catalog_demo",
          "مشاهده قیمت و پلن‌ها": "view_pricing_plans",
          "مقایسه پلن‌ها": "compare_plans",
          "ثبت درخواست همکاری/نمایندگی": "apply_for_partnership",
          "دریافت مشاوره (غیرتخصصی)": "get_general_consultation",
          "بدون دعوت به فراخوانی": "no_call_to_action",
        },

        // === اهداف ===
        goals: {
          // فروش
          "معرفی محصول/خدمت": "introduce_product_service",
          "افزایش فروش": "increase_sales",
          "پیشنهاد محصول مناسب": "recommend_suitable_product",
          "پاسخ به اعتراضات خرید": "handle_objections",
          "آپ‌سل/کراس‌سل (پیشنهاد تکمیلی)": "upsell_crosssell",
          "هدایت به پرداخت/ثبت سفارش": "guide_to_payment",
          // پشتیبانی
          "پاسخ‌گویی به سوالات مشتری (FAQ)": "answer_faqs",
          "راهنمای استفاده/نصب/راه‌اندازی": "usage_setup_guide",
          "پیگیری سفارش/ارسال": "order_tracking",
          "مرجوعی/گارانتی/تعویض": "returns_warranty",
          "ثبت تیکت/شکایت/بازخورد": "log_ticket_complaint",
          "راهنمایی حل مشکل (Troubleshooting)": "troubleshooting",
          // جذب
          "جمع‌آوری لید (نام/شماره/نیاز)": "lead_collection",
          "رزرو وقت/نوبت": "appointment_booking",
          "ثبت‌نام/عضویت": "registration",
          "معرفی نمایندگی/شعب": "introduce_branches",
          "پاسخ‌گویی چندزبانه": "multilingual_support",
          "آموزش و آگاهی‌سازی (قبل از خرید)": "pre_purchase_education",
        },

        // === محدودیت‌ها ===
        constraints: {
          "عدم ارائه توصیه پزشکی": "no_medical_advice",
          "عدم ارائه مشاوره حقوقی": "no_legal_advice",
          "عدم ارائه مشاوره مالی/سرمایه‌گذاری": "no_financial_advice",
          "عدم ارائه اطلاعات فنی خطرناک": "no_dangerous_technical_info",
          "عدم ارائه دستور ساخت مواد/ابزار خطرناک": "no_hazardous_instructions",
          "عدم ادعاهای قطعی/درمانی": "no_definitive_claims",
          "عدم اغراق تبلیغاتی": "no_exaggerated_claims",
          "فقط با داده معتبر (برچسب/کاتالوگ)": "only_verified_data",
          "عدم مقایسه بدون داده معتبر": "no_unverified_comparison",
          "عدم قیمت‌سازی (اگر قیمت نداریم)": "no_price_invention",
          "عدم درخواست اطلاعات حساس (کارت/رمز)": "no_sensitive_data_request",
          "حداقل‌سازی جمع‌آوری داده": "minimize_data_collection",
          "ارجاع به پشتیبانی برای موارد حساس": "refer_sensitive_to_support",
        },

        // === کلیدواژه‌ها ===
        keywords: {
          // عمومی
          "قیمت / هزینه": "price_cost",
          "تخفیف / جشنواره": "discount_promotion",
          "نحوه خرید": "how_to_buy",
          "ارسال / زمان تحویل": "shipping_delivery_time",
          "شرایط مرجوعی": "return_policy",
          گارانتی: "warranty",
          پشتیبانی: "support",
          مقایسه: "comparison",
          موجودی: "availability",
          "روش پرداخت": "payment_method",
          // فنی
          ویژگی‌ها: "features",
          "مزایا و ارزش‌ها": "benefits_value",
          "نحوه استفاده": "how_to_use",
          ایمنی: "safety",
          نگهداری: "maintenance",
          سازگاری: "compatibility",
          "نصب / راه‌اندازی": "installation_setup",
          عیب‌یابی: "troubleshooting",
          "مصرف انرژی/منابع": "energy_resource_consumption",
          "کیفیت/استانداردها": "quality_standards",
          // B2B
          "خرید عمده": "bulk_purchase",
          "قرارداد سازمانی": "corporate_contract",
          "دموی محصول": "product_demo",
          "قیمت‌گذاری پلن‌ها": "pricing_plans",
          "SLA و پشتیبانی سازمانی": "sla_corporate_support",
          "آموزش تیم": "team_training",
        },

        // === منطق تصمیم‌گیری ===
        decisionLogic: {
          "فروش بر پشتیبانی مقدم است": "sales_over_support",
          "پشتیبانی بر فروش مقدم است": "support_over_sales",
          "راهنمایی بی‌طرفانه (بدون فشار)": "neutral_guidance",
          "بسته به نوع سؤال تصمیم‌گیری شود": "context_dependent",
          "توقف پاسخ و اعلام عدم‌اطلاعی": "declare_unknown",
          "درخواست اطلاعات تکمیلی": "ask_for_more_info",
          "ارائه راهنمای کلی ایمن": "provide_safe_general_guidance",
          "پیشنهاد مسیر جایگزین": "suggest_alternative",
        },

        // === کنترل کیفیت ===
        qualityControl: {
          "بررسی تطابق پاسخ با محدودیت‌ها": "check_constraint_compliance",
          "جلوگیری از اغراق تبلیغاتی": "prevent_exaggeration",
          "حذف حدس و فرض‌های نامطمئن": "remove_uncertain_assumptions",
          "ساده‌سازی زبان در پاسخ‌های پیچیده": "simplify_complex_language",
          "کوتاه‌سازی پاسخ‌های بیش‌ازحد طولانی": "shorten_excessively_long",
        },

        // === تحلیل احساسی ===
        sentimentDetection: {
          "تشخیص نارضایتی یا عصبانیت": "detect_dissatisfaction_anger",
          "تشخیص تردید در خرید": "detect_purchase_hesitation",
          "تشخیص عجله یا کم‌حوصلگی": "detect_rush_impatience",
          "تشخیص نیاز به اطمینان‌بخشی": "detect_reassurance_needed",
        },

        sentimentReaction: {
          "کاهش لحن فروش": "reduce_sales_tone",
          "همدلی و عذرخواهی حرفه‌ای": "empathy_professional_apology",
          "ارائه پاسخ کوتاه و سریع": "provide_quick_short_response",
          "ارجاع مستقیم به پشتیبانی انسانی": "direct_referral_to_human_support",
        },

        // === خط مشی برند ===
        brandPolicy: {
          "عدم استفاده از ایموجی": "no_emoji",
          "عدم شوخی یا لحن خودمانی": "no_casual_humor",
          "عدم اشاره به رقبا": "no_competitor_mention",
          "عدم مقایسه مستقیم": "no_direct_comparison",
          "استفاده از واژگان رسمی برند": "use_formal_brand_terminology",
        },

        // === رفتار در تکرار سوال ===
        repetitionBehavior: {
          "پاسخ خلاصه‌تر از قبل": "shorter_summary",
          "ارجاع به پاسخ قبلی": "refer_to_previous_answer",
          "ارائه نسخه مرحله‌ای": "provide_staged_version",
          "پرسش برای شفاف‌سازی نیاز کاربر": "ask_for_clarification",
        },
      },
      selectedMainIndustry: null,
      valid: false,
      loading: false,
      isAddingCustomOption: false,
      isAddingBannedWords: false,
      panels: 0,
      showPromptDialog: false,
      showAddCustomDialog: false,
      customOptionText: "",
      currentCustomField: null,
      selectedMainIndustry: null,
      selectedSubIndustries: [],
      generatedPrompt: "",

      formData: {
        selectedMainIndustry: null,
        selectedIndustries: [],
        assistantName: "",
        assistantType: null,
        productServiceNature: null,
        productServiceType: null,
        organizationType: null,
        productServiceTypeDetail: null,
        brandSpec: null,
        referenceStyle: null,
        salesGoals: [],
        supportGoals: [],
        engagementGoals: [],
        tone: null,
        personality: null,
        responseLength: null,
        preferredStructure: null,
        informationSource: null,
        noInformationBehavior: null,
        contentSensitivity: [],
        claimControl: [],
        privacySecurity: [],
        generalKeywords: [],
        technicalKeywords: [],
        b2bKeywords: [],
        callToActionType: null,
        customCallToAction: "",
        goalPriority: [],
        noInfoBehavior: [],
        qualityControl: [],
        emotionalDetection: [],
        emotionalReaction: [],
        brandPolicy: [],
        bannedWords: "",
        repeatQuestionBehavior: [],
        additionalInfo: "",
      },

      rules: {
        required: (v) => !!v || "این فیلد الزامی است",
        maxFive: (v) => !v || v.length <= 5 || "حداکثر ۵ مورد قابل انتخاب است",
      },

      // داده‌های استاتیک
      assistantTypes: [
        "دستیار فروش",
        "دستیار پشتیبانی",
        "دستیار راهنما",
        "دستیار مشاور",
        "دستیار اختصاصی برند",
        "دستیار پاسخ‌گوی واتساپ/دایرکت",
        "دستیار پاسخ‌گوی سایت",
        "دستیار پاسخ‌گوی تلفنی",
        "دستیار آموزش محصول",
        "دستیار پیگیری سفارش",
        "دستیار قبل از خرید",
        "دستیار بعد از خرید",
        "دستیار سازمانی (B2B)",
        "دستیار نمایندگی‌ها",
        "دستیار خدمات پس از فروش",
        "دستیار ثبت شکایت و بازخورد",
        "دستیار محتوای محصول (FAQ ساز)",
        "دستیار مقایسه و انتخاب محصول",
      ],

      productServiceTypes: [
        "محصول فیزیکی (کالای مصرفی)",
        "محصول فیزیکی (کالای بادوام)",
        "خدمت حضوری",
        "خدمت آنلاین",
        "نرم‌افزار / اپلیکیشن (B2C)",
        "نرم‌افزار / SaaS (B2B)",
        "پلتفرم / مارکت‌پلیس",
        "اشتراک / عضویت",
        "دوره آموزشی / محتوا",
        "سرویس مالی (غیرمشاوره‌ای)",
        "سرویس سلامت عمومی (غیرپزشکی)",
        "رسانه / سرگرمی / محتوا",
        "رویداد / همایش / ورکشاپ",
        "سازمان / برند چندمحصولی",
      ],

      mainIndustries: [
        {
          id: 1,
          name: "صنایع مصرفی و فیزیکی",
          subIndustries: [
            "مواد غذایی",
            "نوشیدنی",
            "شوینده و بهداشتی",
            "آرایشی و مراقبت پوست/مو",
            "عطر و ادکلن",
            "داروخانه‌ای OTC (بدون مشاوره پزشکی)",
            "پوشاک و مد",
            "کفش و کیف",
            "جواهرات و اکسسوری",
            "لوازم خانگی برقی",
            "لوازم آشپزخانه",
            "مبلمان و دکوراسیون",
            "لوازم خواب و کالای خانه",
            "کالای کودک و نوزاد",
            "لوازم تحریر و کتاب",
            "حیوانات خانگی (غذا/لوازم)",
            "ابزار و یراق / DIY",
            "کشاورزی و باغبانی (مصرفی)",
          ],
        },
        {
          id: 2,
          name: "دیجیتال و فناوری",
          subIndustries: [
            "نرم‌افزار و SaaS",
            "اپلیکیشن موبایل",
            "سرویس ابری / هاستینگ",
            "امنیت سایبری (غیرتخصصی)",
            "هوش مصنوعی (محصول/سرویس)",
            "سخت‌افزار و الکترونیک",
            "موبایل و گجت",
            "گیم و سرگرمی دیجیتال",
            "فین‌تک (پرداخت/کیف‌پول)",
            "رمزارز (اطلاع‌رسانی غیرمالی)",
            "مارکت‌پلیس و پلتفرم",
            "مخابرات و اینترنت",
            "ابزارهای تیمی/CRM/ERP",
          ],
        },
        {
          id: 3,
          name: "خدمات و B2B",
          subIndustries: [
            "آموزش و دوره آموزشی",
            "مشاوره کسب‌وکار (غیرحقوقی/غیرمالی تخصصی)",
            "منابع انسانی و استخدام",
            "خدمات سازمانی (B2B)",
            "املاک و مستغلات",
            "ساخت‌وساز و پیمانکاری",
            "گردشگری و هتل‌داری",
            "حمل‌ونقل و لجستیک",
            "خدمات خودرو (تعمیر/لوازم)",
            "بیمه (اطلاع‌رسانی عمومی)",
            "بانکداری (اطلاع‌رسانی عمومی)",
            "خدمات فنی و تعمیرات",
            "رویدادها و نمایشگاه‌ها",
          ],
        },
        {
          id: 4,
          name: "سلامت و سبک زندگی",
          subIndustries: [
            "فیتنس و ورزش",
            "تغذیه عمومی",
            "سلامت عمومی (غیرپزشکی)",
            "روانشناسی عمومی (غیر درمانی)",
            "زیبایی و خدمات سالن",
            "کلینیک زیبایی (اطلاع‌رسانی غیرپزشکی)",
            "مکمل‌ها (اطلاع‌رسانی عمومی)",
            "توسعه فردی و کوچینگ عمومی",
          ],
        },
        {
          id: 5,
          name: "رسانه، فرهنگ، آموزش و محتوا",
          subIndustries: [
            "رسانه و خبر (غیرسیاسی تخصصی)",
            "تولید محتوا/کپی‌رایتینگ",
            "نشر و کتاب",
            "موسیقی و ویدیو",
            "آموزش مدارس/دانشگاه",
            "آموزش مهارتی/فنی",
            "زبان‌آموزی",
          ],
        },
      ],

      organizationTypes: [
        "تولید کننده",
        "توزیع کننده",
        "فروشگاه",
        "استارتاپ",
        "شرکت خدماتی",
        "سازمان B2B",
        "نمایندگی",
      ],

      productServiceTypeDetails: [
        "محصول فیزیکی",
        "خدمت حضوری",
        "خدمت آنلاین",
        "نرم افزار / اپلیکیشن",
        "اشتراکی / دوره ای",
        "چند محصولی",
      ],

      brandSpecs: [
        "اقتصادی",
        "میان رده",
        "پریمیوم",
        "لوکس",
        "سازمانی / شرکتی",
        "نوآور / استارتاپی",
      ],

      referenceStyles: [
        "فقط نام محصول",
        "محصول + برند",
        "برند + سازمان",
        "محصول + برند + سازمان",
      ],

      salesGoals: [
        "معرفی محصول/خدمت",
        "افزایش فروش",
        "پیشنهاد محصول مناسب",
        "پاسخ به اعتراضات خرید",
        "آپ‌سل/کراس‌سل (پیشنهاد تکمیلی)",
        "هدایت به پرداخت/ثبت سفارش",
      ],

      supportGoals: [
        "پاسخ‌گویی به سوالات مشتری (FAQ)",
        "راهنمای استفاده/نصب/راه‌اندازی",
        "پیگیری سفارش/ارسال",
        "مرجوعی/گارانتی/تعویض",
        "ثبت تیکت/شکایت/بازخورد",
        "راهنمایی حل مشکل (Troubleshooting)",
      ],

      engagementGoals: [
        "جمع‌آوری لید (نام/شماره/نیاز)",
        "رزرو وقت/نوبت",
        "ثبت‌نام/عضویت",
        "معرفی نمایندگی/شعب",
        "پاسخ‌گویی چندزبانه",
        "آموزش و آگاهی‌سازی (قبل از خرید)",
      ],

      tones: [
        "کاملاً رسمی",
        "رسمی و حرفه‌ای",
        "نیمه‌رسمی",
        "دوستانه",
        "صمیمی",
        "لوکس و پریمیوم",
        "جوان‌پسند و پرانرژی",
        "مینیمال و خیلی کوتاه",
        "تبلیغاتی (اما بدون اغراق)",
        "مشاوره‌ای",
        "فنی/مهندسی",
        "آموزشی/مدرس‌گونه",
        "همدلانه (پشتیبانی‌محور)",
      ],

      personalities: [
        "دقیق و فنی",
        "ساده و قابل‌فهم",
        "متقاعدکننده",
        "نتیجه‌محور",
        "سوال‌محور (با پرسش‌های کوتاه)",
        "حرفه‌ای و خونسرد",
        "گرم و صمیمی",
        "سخت‌گیر در اطلاعات (بدون حدس)",
        "داستان‌گو (برای بازاریابی)",
        "مقایسه‌گر منطقی",
      ],

      responseLengths: [
        "خیلی کوتاه (۱–۲ جمله)",
        "کوتاه (۲–۴ جمله)",
        "متوسط (۴–۶ جمله)",
        "کامل (۷–۱۲ جمله)",
        "توضیحی (پاراگرافی)",
        "راهنمای مرحله‌ای",
        "FAQ سبک (سؤال/جواب کوتاه)",
        "چک‌لیست‌محور",
        "جدول‌محور (اگر لازم شد)",
      ],

      preferredStructures: [
        "متن ساده",
        "بولت‌پوینت",
        "مراحل شماره‌دار",
        "ترکیبی",
        "سؤال‌های کوتاه برای تکمیل اطلاعات",
        "خلاصه + جزئیات (ابتدا TL;DR)",
      ],

      informationSources: [
        "فقط اطلاعاتی که کاربر می‌دهد",
        "اطلاعات کاربر + توصیه‌های عمومی ایمن",
        "اطلاعات عمومی صنعت (غیرتخصصی)",
        "کاتالوگ/FAQ داخلی (اگر داده دادند)",
        "بدون حدس و فرض (سخت‌گیر)",
        "اطلاعات کاربر + مقایسه کلی بازار (بدون نام برند)",
      ],

      noInformationBehaviors: [
        "اعلام عدم‌اطلاعی",
        "درخواست اطلاعات بیشتر (عکس/لینک/برچسب)",
        "ارائه راهنمای کلی",
        "پیشنهاد مسیر جایگزین (تماس/تیکت)",
        "ترکیب موارد بالا",
        "ارائه چند سناریوی محتمل (با برچسب فرضیگ)",
      ],

      contentSensitivities: [
        "عدم ارائه توصیه پزشکی",
        "عدم ارائه مشاوره حقوقی",
        "عدم ارائه مشاوره مالی/سرمایه‌گذاری",
        "عدم ارائه اطلاعات فنی خطرناک",
        "عدم ارائه دستور ساخت مواد/ابزار خطرناک",
      ],

      claimControls: [
        "عدم ادعاهای قطعی/درمانی",
        "عدم اغراق تبلیغاتی",
        "فقط با داده معتبر (برچسب/کاتالوگ)",
        "عدم مقایسه بدون داده معتبر",
        "عدم قیمت‌سازی (اگر قیمت نداریم)",
      ],

      privacySecurities: [
        "عدم درخواست اطلاعات حساس (کارت/رمز)",
        "حداقل‌سازی جمع‌آوری داده",
        "ارجاع به پشتیبانی برای موارد حساس",
      ],

      generalKeywords: [
        "قیمت / هزینه",
        "تخفیف / جشنواره",
        "نحوه خرید",
        "ارسال / زمان تحویل",
        "شرایط مرجوعی",
        "گارانتی",
        "پشتیبانی",
        "مقایسه",
        "موجودی",
        "روش پرداخت",
      ],

      technicalKeywords: [
        "ویژگی‌ها",
        "مزایا و ارزش‌ها",
        "نحوه استفاده",
        "ایمنی",
        "نگهداری",
        "سازگاری",
        "نصب / راه‌اندازی",
        "عیب‌یابی",
        "مصرف انرژی/منابع",
        "کیفیت/استانداردها",
      ],

      b2bKeywords: [
        "خرید عمده",
        "قرارداد سازمانی",
        "دموی محصول",
        "قیمت‌گذاری پلن‌ها",
        "SLA و پشتیبانی سازمانی",
        "آموزش تیم",
      ],

      callToActionTypes: [
        "دعوت به خرید",
        "درخواست اطلاعات بیشتر",
        "هدایت به لینک",
        "تماس با پشتیبانی",
        "ثبت‌نام",
        "رزرو وقت/نوبت",
        "دریافت کاتالوگ/دمو",
        "مشاهده قیمت و پلن‌ها",
        "مقایسه پلن‌ها",
        "ثبت درخواست همکاری/نمایندگی",
        "دریافت مشاوره (غیرتخصصی)",
        "بدون دعوت به فراخوانی",
        "custom",
      ],

      goalPriorities: [
        "فروش بر پشتیبانی مقدم است",
        "پشتیبانی بر فروش مقدم است",
        "راهنمایی بی‌طرفانه (بدون فشار)",
        "بسته به نوع سؤال تصمیم‌گیری شود",
      ],

      noInfoBehaviors: [
        "توقف پاسخ و اعلام عدم‌اطلاعی",
        "درخواست اطلاعات تکمیلی",
        "ارائه راهنمای کلی ایمن",
        "پیشنهاد مسیر جایگزین",
      ],

      qualityControls: [
        "بررسی تطابق پاسخ با محدودیت‌ها",
        "جلوگیری از اغراق تبلیغاتی",
        "حذف حدس و فرض‌های نامطمئن",
        "ساده‌سازی زبان در پاسخ‌های پیچیده",
        "کوتاه‌سازی پاسخ‌های بیش‌ازحد طولانی",
      ],

      emotionalDetections: [
        "تشخیص نارضایتی یا عصبانیت",
        "تشخیص تردید در خرید",
        "تشخیص عجله یا کم‌حوصلگی",
        "تشخیص نیاز به اطمینان‌بخشی",
      ],

      emotionalReactions: [
        "کاهش لحن فروش",
        "همدلی و عذرخواهی حرفه‌ای",
        "ارائه پاسخ کوتاه و سریع",
        "ارجاع مستقیم به پشتیبانی انسانی",
      ],

      brandPolicies: [
        "عدم استفاده از ایموجی",
        "عدم شوخی یا لحن خودمانی",
        "عدم اشاره به رقبا",
        "عدم مقایسه مستقیم",
        "استفاده از واژگان رسمی برند",
      ],

      repeatQuestionBehaviors: [
        "پاسخ خلاصه‌تر از قبل",
        "ارجاع به پاسخ قبلی",
        "ارائه نسخه مرحله‌ای",
        "پرسش برای شفاف‌سازی نیاز کاربر",
      ],
    };
  },

  computed: {
    totalSections() {
      return 16 - this.skippedSections.length;
    },
    bannedWordsList() {
      if (!this.formData.bannedWords) return [];
      return this.formData.bannedWords
        .split("\n")
        .map((w) => w.trim())
        .filter((w) => w.length > 0);
    },
    completedSections() {
      const sections = [
        "basic",
        "industry",
        "product",
        "goals",
        "tone",
        "structure",
        "information",
        "constraints",
        "keywords",
        "cta",
        "decision",
        "quality",
        "sentiment",
        "brand",
        "repetition",
        "additional",
      ];
      return sections.filter((section) => {
        if (this.skippedSections.includes(section)) {
          return false;
        }
        const status = this.getSectionStatus(section);
        return status === "completed" || status === "in-progress";
      }).length;
    },
    sectionColors() {
      return {
        basic: "#3b82f6",
        industry: "#10b981",
        product: "#6366f1",
        goals: "#f59e0b",
        tone: "#ec4899",
        structure: "#84cc16",
        information: "#06b6d4",
        constraints: "#ef4444",
        keywords: "#8b5cf6",
        cta: "#a855f7",
        decision: "#f97316",
        quality: "#3b82f6",
        sentiment: "#ec4899",
        brand: "#dc2626",
        repetition: "#84cc16",
        additional: "#6b7280",
      };
    },
    progressBarBackground() {
      const sections = [
        "basic",
        "industry",
        "product",
        "goals",
        "tone",
        "structure",
        "information",
        "constraints",
        "keywords",
        "cta",
        "decision",
        "quality",
        "sentiment",
        "brand",
        "repetition",
        "additional",
      ];

      const totalSections = sections.length;
      const sectionWidth = 100 / totalSections;
      const gradientStops = [];

      sections.forEach((section, index) => {
        const startPercent = (index / totalSections) * 100;
        const endPercent = ((index + 1) / totalSections) * 100;

        const color = this.sectionColors[section];
        const status = this.getSectionStatus(section);
        const isCompleted = status === "completed" || status === "in-progress";
        const displayColor = isCompleted ? color : "#e5e7eb";

        if (index === 0) {
          gradientStops.push(`${displayColor} 0%`);
        }

        gradientStops.push(`${displayColor} ${endPercent}%`);
      });

      return `linear-gradient(to right, ${gradientStops.join(", ")})`;
    },
    progressGradient() {
      return "success";
    },
    availableSubIndustries() {
      if (!this.selectedMainIndustry) return [];
      const industry = this.mainIndustries.find(
        (i) => i.id === this.selectedMainIndustry
      );
      return industry ? industry.subIndustries : [];
    },
    hasAnyChip() {
      return (
        this.formData.assistantName ||
        this.formData.assistantType ||
        this.formData.productServiceType ||
        this.formData.selectedIndustries.length > 0 ||
        this.formData.organizationType ||
        this.formData.productServiceTypeDetail ||
        this.formData.brandSpec ||
        this.formData.referenceStyle ||
        this.formData.salesGoals.length > 0 ||
        this.formData.supportGoals.length > 0 ||
        this.formData.engagementGoals.length > 0 ||
        this.formData.tone ||
        this.formData.personality ||
        this.formData.responseLength ||
        this.formData.preferredStructure ||
        this.formData.callToActionType
      );
    },
  },

  methods: {
    addBannedWord() {
      if (this.isAddingBannedWord) return;

      if (!this.bannedWordInput || !this.bannedWordInput.trim()) return;
      this.isAddingBannedWord = true;
      try {
        const newWord = this.bannedWordInput.trim();

        if (this.bannedWordsList.includes(newWord)) {
          this.$toast.warning("این کلمه قبلاً اضافه شده است.");
          this.bannedWordInput = "";
          return;
        }

        if (this.formData.bannedWords) {
          this.formData.bannedWords += "\n" + newWord;
        } else {
          this.formData.bannedWords = newWord;
        }

        this.bannedWordInput = "";
      } finally {
        setTimeout(() => {
          this.isAddingBannedWord = false;
        }, 300);
      }
    },

    removeBannedWordByIndex(index) {
      const words = this.bannedWordsList;
      words.splice(index, 1);
      this.formData.bannedWords = words.join("\n");
    },
    loadAssistantData(jsonData) {
      if (!jsonData || !jsonData.data) {
        this.resetForm();
        return;
      }
      const data = jsonData.data;
      // Basic Info
      this.formData.assistantName = data.basic_info?.assistant_name || "";
      this.formData.assistantType = this.reverseMapValue(
        data.basic_info?.assistant_type,
        "assistantType"
      );
      this.formData.productServiceType = this.reverseMapValue(
        data.basic_info?.product_service_nature,
        "productServiceType"
      );

      // Industry
      if (data.industry) {
        // پیدا کردن صنعت اصلی از mainIndustries
        const mainCategory = this.reverseMapValue(
          data.industry.main_category,
          "industryMain"
        );
        if (mainCategory) {
          const industryObj = this.mainIndustries.find(
            (i) => i.name === mainCategory
          );
          if (industryObj) {
            this.selectedMainIndustry = industryObj.id;
            this.formData.selectedMainIndustry = industryObj.name;
          }
        }

        // زیرصنعت‌ها - باید از انگلیسی به فارسی تبدیل شوند
        if (
          data.industry.sub_categories &&
          Array.isArray(data.industry.sub_categories)
        ) {
          this.formData.selectedIndustries = data.industry.sub_categories;
        }
      }

      // Product Specs
      if (data.product_specs) {
        this.formData.organizationType = this.reverseMapValue(
          data.product_specs.organization_type,
          "organizationType"
        );
        this.formData.brandSpec = this.reverseMapValue(
          data.product_specs.brand_positioning,
          "brandSpec"
        );
        this.formData.referenceStyle = this.reverseMapValue(
          data.product_specs.reference_style,
          "referenceStyle"
        );
      }

      // Goals - باید به سه دسته تقسیم شوند
      if (data.goals && Array.isArray(data.goals)) {
        const salesGoalsList = [
          "introduce_product_service",
          "increase_sales",
          "recommend_suitable_product",
          "handle_objections",
          "upsell_crosssell",
          "guide_to_payment",
        ];
        const supportGoalsList = [
          "answer_faqs",
          "usage_setup_guide",
          "order_tracking",
          "returns_warranty",
          "log_ticket_complaint",
          "troubleshooting",
        ];
        const engagementGoalsList = [
          "lead_collection",
          "appointment_booking",
          "registration",
          "introduce_branches",
          "multilingual_support",
          "pre_purchase_education",
        ];

        this.formData.salesGoals = data.goals
          .filter((g) => salesGoalsList.includes(g))
          .map((g) => this.reverseMapValue(g, "goals"));
        this.formData.supportGoals = data.goals
          .filter((g) => supportGoalsList.includes(g))
          .map((g) => this.reverseMapValue(g, "goals"));
        this.formData.engagementGoals = data.goals
          .filter((g) => engagementGoalsList.includes(g))
          .map((g) => this.reverseMapValue(g, "goals"));
      }

      // Tone & Personality
      if (data.tone_personality) {
        this.formData.tone = this.reverseMapValue(
          data.tone_personality.tone,
          "tone"
        );
        this.formData.personality = this.reverseMapValue(
          data.tone_personality.personality,
          "personality"
        );
      }

      // Response Structure
      if (data.response_structure) {
        this.formData.responseLength = this.reverseMapValue(
          data.response_structure.length,
          "responseLength"
        );
        this.formData.preferredStructure = this.reverseMapValue(
          data.response_structure.format,
          "preferredStructure"
        );
      }

      // Information Level
      if (data.information_level) {
        this.formData.informationSource = this.reverseMapValue(
          data.information_level.source,
          "informationSource"
        );
        this.formData.noInformationBehavior = this.reverseMapValue(
          data.information_level.unknown_behavior,
          "noInformationBehavior"
        );
      }

      // Constraints - باید به سه دسته تقسیم شوند
      if (data.constraints && Array.isArray(data.constraints)) {
        const contentSensitivityList = [
          "no_medical_advice",
          "no_legal_advice",
          "no_financial_advice",
          "no_dangerous_technical_info",
          "no_hazardous_instructions",
        ];
        const claimControlList = [
          "no_definitive_claims",
          "no_exaggerated_claims",
          "only_verified_data",
          "no_unverified_comparison",
          "no_price_invention",
        ];
        const privacySecurityList = [
          "no_sensitive_data_request",
          "minimize_data_collection",
          "refer_sensitive_to_support",
        ];

        this.formData.contentSensitivity = data.constraints
          .filter((c) => contentSensitivityList.includes(c))
          .map((c) => this.reverseMapValue(c, "constraints"));
        this.formData.claimControl = data.constraints
          .filter((c) => claimControlList.includes(c))
          .map((c) => this.reverseMapValue(c, "constraints"));
        this.formData.privacySecurity = data.constraints
          .filter((c) => privacySecurityList.includes(c))
          .map((c) => this.reverseMapValue(c, "constraints"));
      }

      // Keywords - باید به سه دسته تقسیم شوند
      if (data.keywords && Array.isArray(data.keywords)) {
        const generalKeywordsList = [
          "price_cost",
          "discount_promotion",
          "how_to_buy",
          "shipping_delivery_time",
          "return_policy",
          "warranty",
          "support",
          "comparison",
          "availability",
          "payment_method",
        ];
        const technicalKeywordsList = [
          "features",
          "benefits_value",
          "how_to_use",
          "safety",
          "maintenance",
          "compatibility",
          "installation_setup",
          "troubleshooting",
          "energy_resource_consumption",
          "quality_standards",
        ];
        const b2bKeywordsList = [
          "bulk_purchase",
          "corporate_contract",
          "product_demo",
          "pricing_plans",
          "sla_corporate_support",
          "team_training",
        ];

        this.formData.generalKeywords = data.keywords
          .filter((k) => generalKeywordsList.includes(k))
          .map((k) => this.reverseMapValue(k, "keywords"));
        this.formData.technicalKeywords = data.keywords
          .filter((k) => technicalKeywordsList.includes(k))
          .map((k) => this.reverseMapValue(k, "keywords"));
        this.formData.b2bKeywords = data.keywords
          .filter((k) => b2bKeywordsList.includes(k))
          .map((k) => this.reverseMapValue(k, "keywords"));
      }

      // Call to Action
      if (data.call_to_action) {
        if (data.call_to_action.type === "custom_text") {
          this.formData.callToActionType = "custom";
          this.formData.customCallToAction =
            data.call_to_action.custom_text || "";
        } else {
          this.formData.callToActionType = this.reverseMapValue(
            data.call_to_action.type,
            "callToAction"
          );
        }
      }

      // Decision Logic
      if (data.decision_logic) {
        if (data.decision_logic.conflict_priority) {
          this.formData.goalPriority = [
            this.reverseMapValue(
              data.decision_logic.conflict_priority,
              "decisionLogic"
            ),
          ];
        }
        if (data.decision_logic.insufficient_data_strategy) {
          this.formData.noInfoBehavior = [
            this.reverseMapValue(
              data.decision_logic.insufficient_data_strategy,
              "decisionLogic"
            ),
          ];
        }
      }

      // Quality Control
      if (data.quality_control && Array.isArray(data.quality_control)) {
        this.formData.qualityControl = data.quality_control.map((qc) =>
          this.reverseMapValue(qc, "qualityControl")
        );
      }

      // Sentiment Analysis
      if (data.sentiment_analysis) {
        if (data.sentiment_analysis.detection_types) {
          this.formData.emotionalDetection =
            data.sentiment_analysis.detection_types.map((dt) =>
              this.reverseMapValue(dt, "sentimentDetection")
            );
        }
        if (data.sentiment_analysis.reaction) {
          this.formData.emotionalReaction = [
            this.reverseMapValue(
              data.sentiment_analysis.reaction,
              "sentimentReaction"
            ),
          ];
        }
      }

      // Brand DNA
      if (data.brand_dna) {
        if (data.brand_dna.rules) {
          this.formData.brandPolicy = data.brand_dna.rules.map((r) =>
            this.reverseMapValue(r, "brandPolicy")
          );
        }
        if (data.brand_dna.forbidden_words) {
          if (Array.isArray(data.brand_dna.forbidden_words)) {
            this.formData.bannedWords =
              data.brand_dna.forbidden_words.join("\n");
          } else if (typeof data.brand_dna.forbidden_words === "string") {
            this.formData.bannedWords = data.brand_dna.forbidden_words.replace(
              /,/g,
              "\n"
            );
          }
        }
      }

      // Repetition Behavior
      if (data.repetition_behavior) {
        // اگر string است
        if (typeof data.repetition_behavior === "string") {
          // چک می‌کنیم آیا این یک کلید انگلیسی است یا متن فارسی
          const mapped = this.reverseMapValue(
            data.repetition_behavior,
            "repetitionBehavior"
          );
          this.formData.repeatQuestionBehavior = mapped
            ? [mapped]
            : [data.repetition_behavior];
        } else if (Array.isArray(data.repetition_behavior)) {
          this.formData.repeatQuestionBehavior = data.repetition_behavior.map(
            (rb) => this.reverseMapValue(rb, "repetitionBehavior")
          );
        }
      }

      // Additional Info
      this.formData.additionalInfo = data.additional_info || "";
    },

    // Helper: تبدیل مقدار انگلیسی به فارسی (reverse mapping)
    reverseMapValue(enValue, mappingKey) {
      if (!enValue) return null;
      if (!this.mappings || !this.mappings[mappingKey]) {
        return enValue;
      }

      const mapping = this.mappings[mappingKey];
      // جستجو در mapping برای پیدا کردن کلید فارسی
      for (const [faKey, enKey] of Object.entries(mapping)) {
        if (enKey === enValue) {
          return faKey;
        }
      }

      // اگر پیدا نشد، همان مقدار را برمی‌گرداند (ممکن است از قبل فارسی باشد)
      return enValue;
    },
    getSectionStatus(sectionKey) {
      if (this.skippedSections.includes(sectionKey)) {
        return "skipped";
      }

      const data = this.formData;

      switch (sectionKey) {
        case "basic":
          return data.assistantName &&
            data.assistantType &&
            data.productServiceType
            ? "completed"
            : data.assistantName ||
              data.assistantType ||
              data.productServiceType
            ? "in-progress"
            : "empty";
        case "industry":
          return data.selectedIndustries?.length > 0
            ? "completed"
            : data.selectedMainIndustry
            ? "in-progress"
            : "empty";
        case "product":
          const productFields = [
            data.organizationType,
            data.productServiceTypeDetail,
            data.brandSpec,
            data.referenceStyle,
          ];
          const filledProductFields = productFields.filter((f) => f).length;
          if (filledProductFields === 4) return "completed";
          if (filledProductFields > 0) return "in-progress";
          return "empty";
        case "goals":
          const goalsArrays = [
            data.salesGoals?.length > 0,
            data.supportGoals?.length > 0,
            data.engagementGoals?.length > 0,
          ];
          const filledGoalsCount = goalsArrays.filter(Boolean).length;
          if (filledGoalsCount === 3) return "completed";
          if (filledGoalsCount > 0) return "in-progress";
          return "empty";
        case "tone":
          return data.tone && data.personality
            ? "completed"
            : data.tone || data.personality
            ? "in-progress"
            : "empty";
        case "structure":
          return data.responseLength && data.preferredStructure
            ? "completed"
            : data.responseLength || data.preferredStructure
            ? "in-progress"
            : "empty";
        case "information":
          return data.informationSource && data.noInformationBehavior
            ? "completed"
            : data.informationSource || data.noInformationBehavior
            ? "in-progress"
            : "empty";
        case "constraints":
          const constraintsArrays = [
            data.contentSensitivity?.length > 0,
            data.claimControl?.length > 0,
            data.privacySecurity?.length > 0,
          ];
          const filledConstraintsCount =
            constraintsArrays.filter(Boolean).length;
          if (filledConstraintsCount === 3) return "completed";
          if (filledConstraintsCount > 0) return "in-progress";
          return "empty";
        case "keywords":
          const keywordsArrays = [
            data.generalKeywords?.length > 0,
            data.technicalKeywords?.length > 0,
            data.b2bKeywords?.length > 0,
          ];
          const filledKeywordsCount = keywordsArrays.filter(Boolean).length;
          if (filledKeywordsCount === 3) return "completed";
          if (filledKeywordsCount > 0) return "in-progress";
          return "empty";

        case "cta":
          return data.callToActionType ? "completed" : "empty";
        case "decision":
          const decisionArrays = [
            data.goalPriority?.length > 0,
            data.noInfoBehavior?.length > 0,
          ];
          const filledDecisionCount = decisionArrays.filter(Boolean).length;
          if (filledDecisionCount === 2) return "completed";
          if (filledDecisionCount > 0) return "in-progress";
          return "empty";
        case "quality":
          return data.qualityControl?.length > 0 ? "completed" : "empty";
        case "sentiment":
          const sentimentArrays = [
            data.emotionalDetection?.length > 0,
            data.emotionalReaction?.length > 0,
          ];
          const filledSentimentCount = sentimentArrays.filter(Boolean).length;
          if (filledSentimentCount === 2) return "completed";
          if (filledSentimentCount > 0) return "in-progress";
          return "empty";
        case "brand":
          const brandPolicyFilled = data.brandPolicy?.length > 0;
          const bannedWordsFilled =
            data.bannedWords && data.bannedWords.trim().length > 0;
          if (brandPolicyFilled && bannedWordsFilled) return "completed";
          if (brandPolicyFilled || bannedWordsFilled) return "in-progress";
          return "empty";
        case "repetition":
          return data.repeatQuestionBehavior?.length > 0
            ? "completed"
            : "empty";
        case "additional":
          return data.additionalInfo ? "completed" : "empty";
        default:
          return "empty";
      }
    },

    getSectionStatusText(sectionKey) {
      const status = this.getSectionStatus(sectionKey);
      const texts = {
        empty: "هنوز تکمیل نشده",
        skipped: "رد شده",
        "in-progress": "در حال تکمیل",
        completed: "تکمیل شده",
      };
      return texts[status] || texts.empty;
    },

    getSectionStatusIcon(sectionKey) {
      const status = this.getSectionStatus(sectionKey);
      const icons = {
        empty: "mdi-circle-outline",
        "in-progress": "mdi-clock-outline",
        completed: "mdi-check-circle",
        skipped: "mdi-close-circle",
      };
      return icons[status] || icons.empty;
    },

    getSectionStatusColor(sectionKey) {
      const status = this.getSectionStatus(sectionKey);
      const colors = {
        empty: "grey",
        "in-progress": "orange",
        completed: "green",
        skipped: "red",
      };
      return colors[status] || colors.empty;
    },

    getSectionStatusTextColor(sectionKey) {
      const status = this.getSectionStatus(sectionKey);
      const colors = {
        empty: "secondary",
        "in-progress": "warning",
        completed: "success",
        skipped: "error",
      };
      return colors[status] || colors.empty;
    },
    skipSection(sectionKey) {
      if (!this.skippedSections.includes(sectionKey)) {
        this.skippedSections.push(sectionKey);
        this.clearSectionData(sectionKey);
      }
    },
    unskipSection(sectionKey) {
      const index = this.skippedSections.indexOf(sectionKey);
      if (index > -1) {
        this.skippedSections.splice(index, 1);
      }
    },
    clearSectionData(sectionKey) {
      const data = this.formData;
      switch (sectionKey) {
        case "industry":
          data.selectedIndustries = [];
          data.selectedMainIndustry = null;
          this.selectedMainIndustry = null;
          break;
        case "product":
          data.organizationType = null;
          data.brandSpec = null;
          data.referenceStyle = null;
          break;
        case "goals":
          data.salesGoals = [];
          data.supportGoals = [];
          data.engagementGoals = [];
          break;
        case "tone":
          data.tone = null;
          data.personality = null;
          break;
        case "structure":
          data.responseLength = null;
          data.preferredStructure = null;
          break;
        case "information":
          data.informationSource = null;
          data.noInformationBehavior = null;
          break;
        case "constraints":
          data.contentSensitivity = [];
          data.claimControl = [];
          data.privacySecurity = [];
          break;
        case "keywords":
          data.generalKeywords = [];
          data.technicalKeywords = [];
          data.b2bKeywords = [];
          break;
        case "cta":
          data.callToActionType = null;
          data.customCallToAction = "";
          break;
        case "decision":
          data.goalPriority = [];
          data.noInfoBehavior = [];
          break;
        case "quality":
          data.qualityControl = [];
          break;
        case "sentiment":
          data.emotionalDetection = [];
          data.emotionalReaction = [];
          break;
        case "brand":
          data.brandPolicy = [];
          data.bannedWords = "";
          break;
        case "repetition":
          data.repeatQuestionBehavior = [];
          break;
        case "additional":
          data.additionalInfo = "";
          break;
      }
    },

    isSectionSkipped(sectionKey) {
      return this.skippedSections.includes(sectionKey);
    },

    provideData() {
      const dataToProvide = {
        assistantTypes: this.assistantTypes,
        productServiceTypes: this.productServiceTypes,
        mainIndustries: this.mainIndustries,
        organizationTypes: this.organizationTypes,
        productServiceTypeDetails: this.productServiceTypeDetails,
        brandSpecs: this.brandSpecs,
        referenceStyles: this.referenceStyles,
        salesGoals: this.salesGoals,
        supportGoals: this.supportGoals,
        engagementGoals: this.engagementGoals,
        tones: this.tones,
        personalities: this.personalities,
        responseLengths: this.responseLengths,
        preferredStructures: this.preferredStructures,
        informationSources: this.informationSources,
        noInformationBehaviors: this.noInformationBehaviors,
        contentSensitivities: this.contentSensitivities,
        claimControls: this.claimControls,
        privacySecurities: this.privacySecurities,
        generalKeywords: this.generalKeywords,
        technicalKeywords: this.technicalKeywords,
        b2bKeywords: this.b2bKeywords,
        callToActionTypes: this.callToActionTypes,
        goalPriorities: this.goalPriorities,
        noInfoBehaviors: this.noInfoBehaviors,
        qualityControls: this.qualityControls,
        emotionalDetections: this.emotionalDetections,
        emotionalReactions: this.emotionalReactions,
        brandPolicies: this.brandPolicies,
        repeatQuestionBehaviors: this.repeatQuestionBehaviors,

        // مقادیر فعلی فرم (formData) — همه وجود دارند
        bannedWords: this.formData.bannedWords,
        additionalInfo: this.formData.additionalInfo,
        customCallToAction: this.formData.customCallToAction,
        selectedMainIndustry: this.formData.selectedMainIndustry,
        selectedIndustries: this.formData.selectedIndustries,
        informationSource: this.formData.informationSource,
        noInformationBehavior: this.formData.noInformationBehavior,
        qualityControl: this.formData.qualityControl,
        emotionalDetection: this.formData.emotionalDetection,
        emotionalReaction: this.formData.emotionalReaction,
        brandPolicy: this.formData.brandPolicy,
        repeatQuestionBehavior: this.formData.repeatQuestionBehavior,
        goalPriority: this.formData.goalPriority,
        noInfoBehavior: this.formData.noInfoBehavior,
        callToActionType: this.formData.callToActionType,
      };

      this.$refs.mobileBuilder?.importData(dataToProvide);
    },
    convertToJson() {
      const json = {
        basic_info: {
          assistant_name: this.formData.assistantName,
          assistant_type: this.mapValue(
            this.formData.assistantType,
            "assistantType"
          ),
          product_service_nature: this.mapValue(
            this.formData.productServiceType,
            "productServiceType"
          ),
        },
        industry: {
          main_category: this.mapValue(
            this.formData.selectedMainIndustry,
            "industryMain"
          ),
          sub_categories: this.formData.selectedIndustries.map((sub) =>
            this.mapValue(sub, "industrySub")
          ),
        },
        product_specs: {
          organization_type: this.mapValue(
            this.formData.organizationType,
            "organizationType"
          ),
          brand_positioning: this.mapValue(
            this.formData.brandSpec,
            "brandSpec"
          ),
          reference_style: this.mapValue(
            this.formData.referenceStyle,
            "referenceStyle"
          ),
        },
        goals: [
          ...this.formData.salesGoals.map((g) => this.mapValue(g, "goals")),
          ...this.formData.supportGoals.map((g) => this.mapValue(g, "goals")),
          ...this.formData.engagementGoals.map((g) =>
            this.mapValue(g, "goals")
          ),
        ],
        tone_personality: {
          tone: this.mapValue(this.formData.tone, "tone"),
          personality: this.mapValue(this.formData.personality, "personality"),
        },
        response_structure: {
          length: this.mapValue(this.formData.responseLength, "responseLength"),
          format: this.mapValue(
            this.formData.preferredStructure,
            "preferredStructure"
          ),
        },
        information_level: {
          source: this.mapValue(
            this.formData.informationSource,
            "informationSource"
          ),
          unknown_behavior: this.mapValue(
            this.formData.noInformationBehavior,
            "noInformationBehavior"
          ),
        },
        constraints: [
          ...this.formData.contentSensitivity.map((c) =>
            this.mapValue(c, "constraints")
          ),
          ...this.formData.claimControl.map((c) =>
            this.mapValue(c, "constraints")
          ),
          ...this.formData.privacySecurity.map((c) =>
            this.mapValue(c, "constraints")
          ),
        ],
        keywords: [
          ...this.formData.generalKeywords.map((k) =>
            this.mapValue(k, "keywords")
          ),
          ...this.formData.technicalKeywords.map((k) =>
            this.mapValue(k, "keywords")
          ),
          ...this.formData.b2bKeywords.map((k) => this.mapValue(k, "keywords")),
        ],
        call_to_action: {
          type:
            this.formData.callToActionType === "custom"
              ? "custom_text"
              : this.mapValue(this.formData.callToActionType, "callToAction"),
          custom_text:
            this.formData.callToActionType === "custom"
              ? this.formData.customCallToAction
              : null,
        },
        decision_logic: {
          conflict_priority: this.mapValue(
            this.formData.goalPriority[0],
            "decisionLogic"
          ),
          insufficient_data_strategy: this.mapValue(
            this.formData.noInfoBehavior[0],
            "decisionLogic"
          ),
        },
        quality_control: this.formData.qualityControl.map((qc) =>
          this.mapValue(qc, "qualityControl")
        ),
        sentiment_analysis: {
          detection_types: this.formData.emotionalDetection.map((dt) =>
            this.mapValue(dt, "sentimentDetection")
          ),
          reaction: this.mapValue(
            this.formData.emotionalReaction[0],
            "sentimentReaction"
          ),
        },
        brand_dna: {
          rules: this.formData.brandPolicy.map((r) =>
            this.mapValue(r, "brandPolicy")
          ),
          forbidden_words: this.bannedWordsList,
        },
        repetition_behavior:
          this.formData.repeatQuestionBehavior?.length > 0
            ? this.formData.repeatQuestionBehavior[0]
            : this.mapValue(
                this.formData.repeatQuestionBehavior,
                "repetitionBehavior"
              ) || null,

        additional_info: this.formData.additionalInfo || "",
      };

      return json;
    },

    // Helper: تبدیل مقدار فارسی به انگلیسی
    mapValue(faValue, mappingKey) {
      if (!faValue) return null;
      if (!this.mappings || !this.mappings[mappingKey]) {
        return faValue;
      }

      const mapping = this.mappings[mappingKey];
      return mapping && mapping[faValue] ? mapping[faValue] : faValue;
    },
    save() {
      if (this.loading) return;

      if (
        !this.formData.assistantName ||
        this.formData.assistantName.trim() === ""
      ) {
        this.$toast.error("لطفاً نام دستیار را وارد کنید");
        return;
      }
      if (
        !this.formData.assistantType ||
        (typeof this.formData.assistantType === "string" &&
          this.formData.assistantType.trim() === "")
      ) {
        this.$toast.error("لطفاً نوع دستیار را وارد کنید");
        return;
      }
      if (
        !this.formData.productServiceType ||
        (typeof this.formData.productServiceType === "string" &&
          this.formData.productServiceType.trim() === "")
      ) {
        this.$toast.error("لطفاً نوع خدمت یا محصول درخواستی را وارد کنید");
        return;
      }
      this.loading = true;
      try {
        const jsonData = this.convertToJson();
        this.$emit("save", {
          data: jsonData,
          name: this.formData.assistantName,
          type: this.formData.assistantType,
          text: this.generatePrompt(),
        });
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
    cancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    refreshForm() {
      if (this.assistantData) {
        this.loadAssistantData(this.assistantData);
      } else {
        this.resetForm();
      }
    },
    removeBannedWord(word) {
      const words = this.bannedWordsList;
      const index = words.indexOf(word);
      if (index > -1) {
        words.splice(index, 1);
        this.formData.bannedWords = words.join("\n");
      }
    },

    clearField(field) {
      if (Array.isArray(this.formData[field])) {
        this.formData[field] = [];
      } else {
        this.formData[field] = null || "";
      }
    },

    clearCallToAction() {
      this.formData.callToActionType = null;
      this.formData.customCallToAction = "";
    },
    customFilter(item, queryText) {
      return item.toLowerCase().includes(queryText.toLowerCase());
    },

    onMainIndustryChange() {
      this.formData.selectedMainIndustry =
        this.mainIndustries.find((i) => i.id === this.selectedMainIndustry)
          ?.name || null;
      this.formData.selectedIndustries = [];
    },
    onAssistantTypeChange() {
      // منطق تغییرات در صورت نیاز
    },

    removeIndustry(item) {
      const index = this.formData.selectedIndustries.indexOf(item);
      if (index > -1) {
        this.formData.selectedIndustries.splice(index, 1);
      }
    },

    removeFromArray(array, item) {
      const index = array.indexOf(item);
      if (index > -1) {
        this.$delete(array, index);

        // array.splice(index, 1);
      }
    },

    addCustomOption(fieldName) {
      this.currentCustomField = fieldName;
      this.customOptionText = "";
      this.showAddCustomDialog = true;
    },

    addCustomOptionConfirm() {
      if (this.isAddingCustomOption) return;

      this.isAddingCustomOption = true;
      try {
        if (this.customOptionText.trim()) {
          const field = this[this.getFieldItemsName(this.currentCustomField)];
          if (field && Array.isArray(field)) {
            const trimmedText = this.customOptionText.trim();
            if (field.includes(trimmedText)) {
              this.$toast.warning("این مورد قبلاً اضافه شده است.");
              return;
            }

            field.push(this.customOptionText.trim());
            if (Array.isArray(this.formData[this.currentCustomField])) {
              this.formData[this.currentCustomField].push(
                this.customOptionText.trim()
              );
            } else {
              this.formData[this.currentCustomField] = [
                this.customOptionText.trim(),
              ];
            }
          }
          this.showAddCustomDialog = false;
          this.customOptionText = "";
          this.currentCustomField = null;
        }
      } catch (error) {
        this.$toast.error("خطایی رخ داده است. لطفا دوباره تلاش کنید.");
      } finally {
        setTimeout(() => {
          this.isAddingCustomOption = false;
        }, 300);
      }
    },

    getFieldItemsName(fieldName) {
      const mapping = {
        contentSensitivity: "contentSensitivities",
        claimControl: "claimControls",
        privacySecurity: "privacySecurities",
        generalKeywords: "generalKeywords",
        technicalKeywords: "technicalKeywords",
        b2bKeywords: "b2bKeywords",
        goalPriority: "goalPriorities",
        noInfoBehavior: "noInfoBehaviors",
        qualityControl: "qualityControls",
        emotionalDetection: "emotionalDetections",
        emotionalReaction: "emotionalReactions",
        brandPolicy: "brandPolicies",
        repeatQuestionBehavior: "repeatQuestionBehaviors",
      };
      return mapping[fieldName] || fieldName;
    },

    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.skippedSections = [];

      this.formData = {
        assistantName: "",
        assistantType: null,
        productServiceType: null,
        selectedIndustries: [],
        organizationType: null,
        productServiceTypeDetail: null,
        brandSpec: null,
        referenceStyle: null,
        salesGoals: [],
        supportGoals: [],
        engagementGoals: [],
        tone: null,
        personality: null,
        responseLength: null,
        preferredStructure: null,
        informationSource: null,
        noInformationBehavior: null,
        contentSensitivity: [],
        claimControl: [],
        privacySecurity: [],
        generalKeywords: [],
        technicalKeywords: [],
        b2bKeywords: [],
        callToActionType: null,
        customCallToAction: "",
        goalPriority: [],
        noInfoBehavior: [],
        qualityControl: [],
        emotionalDetection: [],
        emotionalReaction: [],
        brandPolicy: [],
        bannedWords: "",
        repeatQuestionBehavior: [],
        additionalInfo: "",
      };
      this.selectedMainIndustry = null;
      this.panels = 0;
      this.contentSensitivities = [
        "عدم ارائه توصیه پزشکی",
        "عدم ارائه مشاوره حقوقی",
        "عدم ارائه مشاوره مالی/سرمایه‌گذاری",
        "عدم ارائه اطلاعات فنی خطرناک",
        "عدم ارائه دستور ساخت مواد/ابزار خطرناک",
      ];

      this.claimControls = [
        "عدم ادعاهای قطعی/درمانی",
        "عدم اغراق تبلیغاتی",
        "فقط با داده معتبر (برچسب/کاتالوگ)",
        "عدم مقایسه بدون داده معتبر",
        "عدم قیمت‌سازی (اگر قیمت نداریم)",
      ];

      this.privacySecurities = [
        "عدم درخواست اطلاعات حساس (کارت/رمز)",
        "حداقل‌سازی جمع‌آوری داده",
        "ارجاع به پشتیبانی برای موارد حساس",
      ];

      this.generalKeywords = [
        "قیمت / هزینه",
        "تخفیف / جشنواره",
        "نحوه خرید",
        "ارسال / زمان تحویل",
        "شرایط مرجوعی",
        "گارانتی",
        "پشتیبانی",
        "مقایسه",
        "موجودی",
        "روش پرداخت",
      ];

      this.technicalKeywords = [
        "ویژگی‌ها",
        "مزایا و ارزش‌ها",
        "نحوه استفاده",
        "ایمنی",
        "نگهداری",
        "سازگاری",
        "نصب / راه‌اندازی",
        "عیب‌یابی",
        "مصرف انرژی/منابع",
        "کیفیت/استانداردها",
      ];

      this.b2bKeywords = [
        "خرید عمده",
        "قرارداد سازمانی",
        "دموی محصول",
        "قیمت‌گذاری پلن‌ها",
        "SLA و پشتیبانی سازمانی",
        "آموزش تیم",
      ];

      this.goalPriorities = [
        "فروش بر پشتیبانی مقدم است",
        "پشتیبانی بر فروش مقدم است",
        "راهنمایی بی‌طرفانه (بدون فشار)",
        "بسته به نوع سؤال تصمیم‌گیری شود",
      ];

      this.noInfoBehaviors = [
        "توقف پاسخ و اعلام عدم‌اطلاعی",
        "درخواست اطلاعات تکمیلی",
        "ارائه راهنمای کلی ایمن",
        "پیشنهاد مسیر جایگزین",
      ];

      this.qualityControls = [
        "بررسی تطابق پاسخ با محدودیت‌ها",
        "جلوگیری از اغراق تبلیغاتی",
        "حذف حدس و فرض‌های نامطمئن",
        "ساده‌سازی زبان در پاسخ‌های پیچیده",
        "کوتاه‌سازی پاسخ‌های بیش‌ازحد طولانی",
      ];

      this.emotionalDetections = [
        "تشخیص نارضایتی یا عصبانیت",
        "تشخیص تردید در خرید",
        "تشخیص عجله یا کم‌حوصلگی",
        "تشخیص نیاز به اطمینان‌بخشی",
      ];

      this.emotionalReactions = [
        "کاهش لحن فروش",
        "همدلی و عذرخواهی حرفه‌ای",
        "ارائه پاسخ کوتاه و سریع",
        "ارجاع مستقیم به پشتیبانی انسانی",
      ];

      this.brandPolicies = [
        "عدم استفاده از ایموجی",
        "عدم شوخی یا لحن خودمانی",
        "عدم اشاره به رقبا",
        "عدم مقایسه مستقیم",
        "استفاده از واژگان رسمی برند",
      ];

      this.repeatQuestionBehaviors = [
        "پاسخ خلاصه‌تر از قبل",
        "ارجاع به پاسخ قبلی",
        "ارائه نسخه مرحله‌ای",
        "پرسش برای شفاف‌سازی نیاز کاربر",
      ];
    },
    jsonToPrompt(jsonData) {
      if (!jsonData) return "";

      // متن پایه
      let prompt = `<< این دستیار نمایندهٔ رسمی اطلاعات و راهنمایی‌های مرتبط با محصول/خدمت تعریف‌شده در این پرامپت است.
تمام پاسخ‌ها باید مستقیماً به این محصول یا خدمات وابسته به آن مربوط باشند.
در صورت دریافت سؤال نامرتبط، از پاسخ‌گویی خودداری کرده و با حفظ لحن حرفه‌ای، کاربر را به طرح سؤال مرتبط با محصول هدایت کنید. >>

# مشخصات دستیار

## مشخصات پایه
- نام دستیار: ${jsonData.basic_info?.assistant_name || "تعیین نشده"}
- نوع دستیار: ${jsonData.basic_info?.assistant_type || "تعیین نشده"}
- نوع محصول/خدمت: ${jsonData.basic_info?.product_service_nature || "تعیین نشده"}
`;

      // افزودن اطلاعات صنعت
      if (jsonData.industry?.sub_categories?.length > 0) {
        prompt += `\n## صنعت/حوزه فعالیت`;
        if (jsonData.industry.main_category) {
          prompt += `\n- صنعت اصلی: ${jsonData.industry.main_category}`;
        }
        prompt += `\n${jsonData.industry.sub_categories
          .map((ind) => `- ${ind}`)
          .join("\n")}`;
      }

      // افزودن مشخصات محصول
      if (jsonData.product_specs) {
        const specs = jsonData.product_specs;
        if (
          specs.organization_type ||
          specs.brand_positioning ||
          specs.reference_style
        ) {
          prompt += `\n## مشخصات محصول/خدمت`;
          if (specs.organization_type) {
            prompt += `\n- نوع سازمان: ${specs.organization_type}`;
          }
          if (specs.brand_positioning) {
            prompt += `\n- مشخصات برند: ${specs.brand_positioning}`;
          }
          if (specs.reference_style) {
            prompt += `\n- نحوه اشاره در پاسخ: ${specs.reference_style}`;
          }
        }
      }

      // افزودن اهداف
      if (jsonData.goals?.length > 0) {
        prompt += `\n## هدف دستیار\n${jsonData.goals
          .map((g) => `- ${g}`)
          .join("\n")}`;
      }

      // لحن و شخصیت
      if (jsonData.tone_personality) {
        const tp = jsonData.tone_personality;
        if (tp.tone || tp.personality) {
          prompt += `\n## لحن و شخصیت`;
          if (tp.tone) {
            prompt += `\n- لحن: ${tp.tone}`;
          }
          if (tp.personality) {
            prompt += `\n- شخصیت: ${tp.personality}`;
          }
        }
      }

      // ساختار پاسخ
      if (jsonData.response_structure) {
        const rs = jsonData.response_structure;
        if (rs.length || rs.format) {
          prompt += `\n## ساختار پاسخ`;
          if (rs.length) {
            prompt += `\n- طول پاسخ: ${rs.length}`;
          }
          if (rs.format) {
            prompt += `\n- ساختار: ${rs.format}`;
          }
        }
      }

      // سطح اطلاعات
      if (jsonData.information_level) {
        const il = jsonData.information_level;
        if (il.source || il.unknown_behavior) {
          prompt += `\n## سطح مجاز اطلاعات`;
          if (il.source) {
            prompt += `\n- منبع: ${il.source}`;
          }
          if (il.unknown_behavior) {
            prompt += `\n- رفتار در نبود اطلاعات: ${il.unknown_behavior}`;
          }
        }
      }

      // محدودیت‌ها
      if (jsonData.constraints?.length > 0) {
        prompt += `\n## محدودیت‌ها\n${jsonData.constraints
          .map((c) => `- ${c}`)
          .join("\n")}`;
      }

      // کلیدواژه‌ها
      if (jsonData.keywords?.length > 0) {
        prompt += `\n## کلیدواژه‌های مهم\n${jsonData.keywords
          .map((k) => `- ${k}`)
          .join("\n")}`;
      }

      // فراخوان
      if (jsonData.call_to_action) {
        const cta = jsonData.call_to_action;
        if (cta.type) {
          prompt += `\n## نوع فراخوان: `;
          if (cta.type === "custom_text" && cta.custom_text) {
            prompt += cta.custom_text;
          } else {
            prompt += cta.type;
          }
        }
      }

      // منطق تصمیم‌گیری
      if (jsonData.decision_logic) {
        const dl = jsonData.decision_logic;
        if (dl.conflict_priority || dl.insufficient_data_strategy) {
          prompt += `\n## منطق تصمیم‌گیری`;
          if (dl.conflict_priority) {
            prompt += `\n- اولویت اهداف: ${dl.conflict_priority}`;
          }
          if (dl.insufficient_data_strategy) {
            prompt += `\n- رفتار در نبود اطلاعات: ${dl.insufficient_data_strategy}`;
          }
        }
      }

      // کنترل کیفیت
      if (jsonData.quality_control?.length > 0) {
        prompt += `\n## کنترل کیفیت\n${jsonData.quality_control
          .map((q) => `- ${q}`)
          .join("\n")}`;
      }

      // تشخیص احساسی
      if (jsonData.sentiment_analysis) {
        const sa = jsonData.sentiment_analysis;
        if (sa.detection_types?.length > 0 || sa.reaction) {
          prompt += `\n## تشخیص وضعیت احساسی`;
          if (sa.detection_types?.length > 0) {
            prompt += `\n- نوع تشخیص:\n${sa.detection_types
              .map((d) => `  - ${d}`)
              .join("\n")}`;
          }
          if (sa.reaction) {
            prompt += `\n- واکنش: ${sa.reaction}`;
          }
        }
      }

      // خط مشی برند
      if (jsonData.brand_dna) {
        const bd = jsonData.brand_dna;
        if (bd.rules?.length > 0 || bd.forbidden_words?.length > 0) {
          prompt += `\n## خط مشی و DNA برند`;
          if (bd.rules?.length > 0) {
            prompt += `\n${bd.rules.map((r) => `- ${r}`).join("\n")}`;
          }
          if (bd.forbidden_words?.length > 0) {
            prompt += `\n- کلمات ممنوعه: ${bd.forbidden_words.join(", ")}`;
          }
        }
      }

      // رفتار در تکرار سوال
      if (jsonData.repetition_behavior) {
        prompt += `\n## رفتار در تکرار سوال\n- ${jsonData.repetition_behavior}`;
      }

      // اطلاعات تکمیلی
      if (jsonData.additional_info) {
        prompt += `\n## اطلاعات تکمیلی\n${jsonData.additional_info}`;
      }

      return prompt;
    },
    generatePrompt() {
      //  this.loading = true;

      // متن پایه
      let prompt = `
# مشخصات دستیار

## مشخصات پایه
- نام دستیار: ${this.formData.assistantName}
- نوع دستیار: ${this.formData.assistantType || "تعیین نشده"}
- نوع محصول/خدمت: ${this.formData.productServiceType || "تعیین نشده"}
`;

      // افزودن اطلاعات صنعت
      if (this.formData.selectedIndustries.length > 0) {
        prompt += `\n## صنعت/حوزه فعالیت
${this.formData.selectedIndustries.map((ind) => `- ${ind}`).join("\n")}`;
      }

      // افزودن مشخصات محصول
      if (
        this.formData.organizationType ||
        this.formData.productServiceTypeDetail ||
        this.formData.brandSpec ||
        this.formData.referenceStyle
      ) {
        prompt += `\n## مشخصات محصول/خدمت`;
        if (this.formData.organizationType) {
          prompt += `\n- نوع سازمان: ${this.formData.organizationType}`;
        }
        if (this.formData.productServiceTypeDetail) {
          prompt += `\n- نوع محصول/خدمت: ${this.formData.productServiceTypeDetail}`;
        }
        if (this.formData.brandSpec) {
          prompt += `\n- مشخصات برند: ${this.formData.brandSpec}`;
        }
        if (this.formData.referenceStyle) {
          prompt += `\n- نحوه اشاره در پاسخ: ${this.formData.referenceStyle}`;
        }
      }

      // افزودن اهداف
      const allGoals = [
        ...this.formData.salesGoals.map((g) => `فروش: ${g}`),
        ...this.formData.supportGoals.map((g) => `پشتیبانی: ${g}`),
        ...this.formData.engagementGoals.map((g) => `جذب: ${g}`),
      ];
      if (allGoals.length > 0) {
        prompt += `\n## هدف دستیار\n${allGoals
          .map((g) => `- ${g}`)
          .join("\n")}`;
      }

      // لحن و شخصیت
      if (this.formData.tone || this.formData.personality) {
        prompt += `\n## لحن و شخصیت`;
        if (this.formData.tone) {
          prompt += `\n- لحن: ${this.formData.tone}`;
        }
        if (this.formData.personality) {
          prompt += `\n- شخصیت: ${this.formData.personality}`;
        }
      }

      // ساختار پاسخ
      if (this.formData.responseLength || this.formData.preferredStructure) {
        prompt += `\n## ساختار پاسخ`;
        if (this.formData.responseLength) {
          prompt += `\n- طول پاسخ: ${this.formData.responseLength}`;
        }
        if (this.formData.preferredStructure) {
          prompt += `\n- ساختار: ${this.formData.preferredStructure}`;
        }
      }

      // سطح اطلاعات
      if (
        this.formData.informationSource ||
        this.formData.noInformationBehavior
      ) {
        prompt += `\n## سطح مجاز اطلاعات`;
        if (this.formData.informationSource) {
          prompt += `\n- منبع: ${this.formData.informationSource}`;
        }
        if (this.formData.noInformationBehavior) {
          prompt += `\n- رفتار در نبود اطلاعات: ${this.formData.noInformationBehavior}`;
        }
      }

      // محدودیت‌ها
      const allLimitations = [
        ...this.formData.contentSensitivity,
        ...this.formData.claimControl,
        ...this.formData.privacySecurity,
      ];
      if (allLimitations.length > 0) {
        prompt += `\n## محدودیت‌ها\n${allLimitations
          .map((l) => `- ${l}`)
          .join("\n")}`;
      }

      // کلیدواژه‌ها
      const allKeywords = [
        ...this.formData.generalKeywords,
        ...this.formData.technicalKeywords,
        ...this.formData.b2bKeywords,
      ];
      if (allKeywords.length > 0) {
        prompt += `\n## کلیدواژه‌های مهم\n${allKeywords
          .map((k) => `- ${k}`)
          .join("\n")}`;
      }

      // فراخوان
      if (this.formData.callToActionType) {
        prompt += `\n## نوع فراخوان: `;
        if (
          this.formData.callToActionType === "custom" &&
          this.formData.customCallToAction
        ) {
          prompt += this.formData.customCallToAction;
        } else {
          prompt += this.formData.callToActionType;
        }
      }

      // منطق تصمیم‌گیری
      if (
        this.formData.goalPriority.length > 0 ||
        this.formData.noInfoBehavior.length > 0
      ) {
        prompt += `\n## منطق تصمیم‌گیری`;
        if (this.formData.goalPriority.length > 0) {
          prompt += `\n- اولویت اهداف:\n${this.formData.goalPriority
            .map((p) => `  - ${p}`)
            .join("\n")}`;
        }
        if (this.formData.noInfoBehavior.length > 0) {
          prompt += `\n- رفتار در نبود اطلاعات:\n${this.formData.noInfoBehavior
            .map((b) => `  - ${b}`)
            .join("\n")}`;
        }
      }

      // کنترل کیفیت
      if (this.formData.qualityControl.length > 0) {
        prompt += `\n## کنترل کیفیت\n${this.formData.qualityControl
          .map((q) => `- ${q}`)
          .join("\n")}`;
      }

      // تشخیص احساسی
      if (
        this.formData.emotionalDetection.length > 0 ||
        this.formData.emotionalReaction.length > 0
      ) {
        prompt += `\n## تشخیص وضعیت احساسی`;
        if (this.formData.emotionalDetection.length > 0) {
          prompt += `\n- نوع تشخیص:\n${this.formData.emotionalDetection
            .map((d) => `  - ${d}`)
            .join("\n")}`;
        }
        if (this.formData.emotionalReaction.length > 0) {
          prompt += `\n- واکنش:\n${this.formData.emotionalReaction
            .map((r) => `  - ${r}`)
            .join("\n")}`;
        }
      }

      // خط مشی برند
      if (this.formData.brandPolicy.length > 0 || this.formData.bannedWords) {
        prompt += `\n## خط مشی و DNA برند`;
        if (this.formData.brandPolicy.length > 0) {
          prompt += `\n${this.formData.brandPolicy
            .map((p) => `- ${p}`)
            .join("\n")}`;
        }
        if (this.formData.bannedWords) {
          prompt += `\n- کلمات ممنوعه: ${this.formData.bannedWords}`;
        }
      }

      // رفتار در تکرار سوال
      if (this.formData.repeatQuestionBehavior.length > 0) {
        prompt += `\n## رفتار در تکرار سوال\n${this.formData.repeatQuestionBehavior
          .map((b) => `- ${b}`)
          .join("\n")}`;
      }

      // اطلاعات تکمیلی
      if (this.formData.additionalInfo) {
        prompt += `\n## اطلاعات تکمیلی\n${this.formData.additionalInfo}`;
      }

      this.generatedPrompt = prompt;
      return prompt;
      //  this.showPromptDialog = true;
      //  this.loading = false;
    },

    copyPrompt() {
      navigator.clipboard.writeText(this.generatedPrompt).then(() => {
        this.$toast.success("پرامپت کپی شد!");
      });
    },
  },
  watch: {
    assistantData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (newVal.data) {
            this.loadAssistantData(newVal);
          } else {
            this.loadAssistantData({ data: newVal });
          }
        } else {
          this.resetForm();
        }
        // this.panels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
        this.panels = 0;
      },
    },
  },
};
</script>

<style scoped>
/* ==================== Expansion Panels Base Styles ==================== */
::v-deep .v-expansion-panel {
  border-radius: 12px !important;
  margin-bottom: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
}

/* Header Base Styles */
::v-deep .v-expansion-panel-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border-bottom: 1px solid #e2e8f0;
  padding: 18px 24px !important;
  min-height: 64px !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent !important;
  position: relative;
}

/* Header Hover State */
::v-deep .v-expansion-panel-header:hover {
  background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%) !important;
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

/* Header Active State */
::v-deep .v-expansion-panel-header--active {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border-radius: 12px 12px 0 0 !important;
  transform: translateY(-1px);
}

/* Header Text Base Styles */
::v-deep .v-expansion-panel-header .text-h6 {
  font-size: 1.15rem !important;
  font-weight: 500;
  color: #1e293b;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

/* Icon Base Styles */
::v-deep .v-expansion-panel-header .v-icon {
  transition: all 0.3s ease;
  color: #64748b;
}

::v-deep .v-expansion-panel-header:hover .v-icon {
  transform: scale(1.1);
}

::v-deep .v-expansion-panel-header--active .v-icon {
  transform: scale(1.15);
}

/* Content Styles */
::v-deep .v-expansion-panel-content__wrap {
  padding: 24px !important;
  background-color: #ffffff;
  border-top: 1px solid #e2e8f0;
}

/* ==================== Panel Colors - Border, Text و Icon در Hover/Active ==================== */

/* Panel 1: مشخصات پایه دستیار - آبی (#3b82f6) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header--active {
  border-color: #3b82f6 !important;
  box-shadow: 0 12px 32px rgba(59, 130, 246, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #3b82f6 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(1)
  .v-expansion-panel-header--active
  .v-icon {
  color: #3b82f6 !important;
}

/* Panel 2: صنعت/حوزه فعالیت - سبز (#10b981) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header--active {
  border-color: #10b981 !important;
  box-shadow: 0 12px 32px rgba(16, 185, 129, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #10b981 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(3)
  .v-expansion-panel-header--active
  .v-icon {
  color: #10b981 !important;
}

/* Panel 3: مشخصات محصول/خدمت - بنفش (#6366f1) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(5)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(5)
  .v-expansion-panel-header--active {
  border-color: #6366f1 !important;
  box-shadow: 0 12px 32px rgba(99, 102, 241, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(5)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(5)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #6366f1 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(5)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(5)
  .v-expansion-panel-header--active
  .v-icon {
  color: #6366f1 !important;
}

/* Panel 4: هدف دستیار - نارنجی (#f59e0b) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(7)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(7)
  .v-expansion-panel-header--active {
  border-color: #f59e0b !important;
  box-shadow: 0 12px 32px rgba(245, 158, 11, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(7)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(7)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #f59e0b !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(7)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(7)
  .v-expansion-panel-header--active
  .v-icon {
  color: #f59e0b !important;
}

/* Panel 5: لحن و شخصیت - صورتی (#ec4899) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(9)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(9)
  .v-expansion-panel-header--active {
  border-color: #ec4899 !important;
  box-shadow: 0 12px 32px rgba(236, 72, 153, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(9)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(9)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #ec4899 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(9)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(9)
  .v-expansion-panel-header--active
  .v-icon {
  color: #ec4899 !important;
}

/* Panel 6: ساختار پاسخ - لیمویی (#84cc16) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(11)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(11)
  .v-expansion-panel-header--active {
  border-color: #84cc16 !important;
  box-shadow: 0 12px 32px rgba(132, 204, 22, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(11)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(11)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #84cc16 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(11)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(11)
  .v-expansion-panel-header--active
  .v-icon {
  color: #84cc16 !important;
}

/* Panel 7: سطح مجاز اطلاعات - فیروزه‌ای (#06b6d4) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(13)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(13)
  .v-expansion-panel-header--active {
  border-color: #06b6d4 !important;
  box-shadow: 0 12px 32px rgba(6, 182, 212, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(13)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(13)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #06b6d4 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(13)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(13)
  .v-expansion-panel-header--active
  .v-icon {
  color: #06b6d4 !important;
}

/* Panel 8: محدودیت‌ها - قرمز (#ef4444) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(15)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(15)
  .v-expansion-panel-header--active {
  border-color: #ef4444 !important;
  box-shadow: 0 12px 32px rgba(239, 68, 68, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(15)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(15)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #ef4444 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(15)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(15)
  .v-expansion-panel-header--active
  .v-icon {
  color: #ef4444 !important;
}

/* Panel 9: کلیدواژه‌ها - بنفش تیره (#8b5cf6) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(17)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(17)
  .v-expansion-panel-header--active {
  border-color: #8b5cf6 !important;
  box-shadow: 0 12px 32px rgba(139, 92, 246, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(17)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(17)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #8b5cf6 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(17)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(17)
  .v-expansion-panel-header--active
  .v-icon {
  color: #8b5cf6 !important;
}

/* Panel 10: نوع فراخوان - بنفش روشن (#a855f7) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(19)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(19)
  .v-expansion-panel-header--active {
  border-color: #a855f7 !important;
  box-shadow: 0 12px 32px rgba(168, 85, 247, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(19)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(19)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #a855f7 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(19)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(19)
  .v-expansion-panel-header--active
  .v-icon {
  color: #a855f7 !important;
}

/* Panel 11: منطق تصمیم‌گیری - نارنجی تیره (#f97316) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(21)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(21)
  .v-expansion-panel-header--active {
  border-color: #f97316 !important;
  box-shadow: 0 12px 32px rgba(249, 115, 22, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(21)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(21)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #f97316 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(21)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(21)
  .v-expansion-panel-header--active
  .v-icon {
  color: #f97316 !important;
}

/* Panel 12: کنترل کیفیت - آبی (#3b82f6) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(23)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(23)
  .v-expansion-panel-header--active {
  border-color: #3b82f6 !important;
  box-shadow: 0 12px 32px rgba(59, 130, 246, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(23)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(23)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #3b82f6 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(23)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(23)
  .v-expansion-panel-header--active
  .v-icon {
  color: #3b82f6 !important;
}

/* Panel 13: تشخیص احساسی - صورتی (#ec4899) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(25)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(25)
  .v-expansion-panel-header--active {
  border-color: #ec4899 !important;
  box-shadow: 0 12px 32px rgba(236, 72, 153, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(25)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(25)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #ec4899 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(25)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(25)
  .v-expansion-panel-header--active
  .v-icon {
  color: #ec4899 !important;
}

/* Panel 14: خط مشی برند - قرمز تیره (#dc2626) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(27)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(27)
  .v-expansion-panel-header--active {
  border-color: #dc2626 !important;
  box-shadow: 0 12px 32px rgba(220, 38, 38, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(27)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(27)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #dc2626 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(27)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(27)
  .v-expansion-panel-header--active
  .v-icon {
  color: #dc2626 !important;
}

/* Panel 15: رفتار در تکرار - لیمویی (#84cc16) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(29)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(29)
  .v-expansion-panel-header--active {
  border-color: #84cc16 !important;
  box-shadow: 0 12px 32px rgba(132, 204, 22, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(29)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(29)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #84cc16 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(29)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(29)
  .v-expansion-panel-header--active
  .v-icon {
  color: #84cc16 !important;
}

/* Panel 16: اطلاعات تکمیلی - خاکستری (#6b7280) */
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(31)
  .v-expansion-panel-header:hover,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(31)
  .v-expansion-panel-header--active {
  border-color: #6b7280 !important;
  box-shadow: 0 12px 32px rgba(107, 114, 128, 0.3) !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(31)
  .v-expansion-panel-header:hover
  .text-h6,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(31)
  .v-expansion-panel-header--active
  .text-h6 {
  color: #6b7280 !important;
  font-weight: 700 !important;
}

::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(31)
  .v-expansion-panel-header:hover
  .v-icon,
::v-deep
  .v-expansion-panels
  > .v-expansion-panel:nth-of-type(31)
  .v-expansion-panel-header--active
  .v-icon {
  color: #6b7280 !important;
}

/* ==================== Chip Styles با رنگ‌های مربوطه ==================== */

/* Chip Base - مشخصات پایه (آبی) */
.chip-base {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%) !important;
  color: #1e40af !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  font-weight: 500 !important;
}

.chip-base:hover {
  background: linear-gradient(135deg, #bfdbfe 0%, #93c5fd 100%) !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4) !important;
}

/* Chip Industry - صنعت (سبز) */
.chip-industry {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%) !important;
  color: #065f46 !important;
  border: 1px solid rgba(16, 185, 129, 0.3) !important;
  font-weight: 500 !important;
}

.chip-industry:hover {
  background: linear-gradient(135deg, #a7f3d0 0%, #6ee7b7 100%) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4) !important;
}

/* Chip Goal - زیرصنعت (سبز) */
.chip-goal {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%) !important;
  color: #065f46 !important;
  border: 1px solid rgba(16, 185, 129, 0.3) !important;
  font-weight: 500 !important;
}

.chip-goal:hover {
  background: linear-gradient(135deg, #a7f3d0 0%, #6ee7b7 100%) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4) !important;
}

/* Chip Product - محصول/خدمت (بنفش) */
.chip-product {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%) !important;
  color: #3730a3 !important;
  border: 1px solid rgba(99, 102, 241, 0.3) !important;
  font-weight: 500 !important;
}

.chip-product:hover {
  background: linear-gradient(135deg, #c7d2fe 0%, #a5b4fc 100%) !important;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4) !important;
}

/* Chip Goals - اهداف (نارنجی) */
.chip-goals {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%) !important;
  color: #92400e !important;
  border: 1px solid rgba(245, 158, 11, 0.3) !important;
  font-weight: 500 !important;
}

.chip-goals:hover {
  background: linear-gradient(135deg, #fde68a 0%, #fcd34d 100%) !important;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4) !important;
}

/* Chip Tone - لحن (صورتی) */
.chip-tone {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%) !important;
  color: #be185d !important;
  border: 1px solid rgba(236, 72, 153, 0.3) !important;
  font-weight: 500 !important;
}

.chip-tone:hover {
  background: linear-gradient(135deg, #fbcfe8 0%, #f9a8d4 100%) !important;
  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.4) !important;
}

/* Chip Structure - ساختار (لیمویی) */
.chip-structure {
  background: linear-gradient(135deg, #ecfccb 0%, #d9f99d 100%) !important;
  color: #4d7c0f !important;
  border: 1px solid rgba(132, 204, 22, 0.3) !important;
  font-weight: 500 !important;
}

.chip-structure:hover {
  background: linear-gradient(135deg, #d9f99d 0%, #bef264 100%) !important;
  box-shadow: 0 4px 12px rgba(132, 204, 22, 0.4) !important;
}

/* Chip Info - اطلاعات (فیروزه‌ای) */
.chip-info {
  background: linear-gradient(135deg, #cffafe 0%, #a5f3fc 100%) !important;
  color: #155e75 !important;
  border: 1px solid rgba(6, 182, 212, 0.3) !important;
  font-weight: 500 !important;
}

.chip-info:hover {
  background: linear-gradient(135deg, #a5f3fc 0%, #67e8f9 100%) !important;
  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.4) !important;
}

/* Chip Restrictions - محدودیت‌ها (قرمز) */
.chip-restrictions {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%) !important;
  color: #991b1b !important;
  border: 1px solid rgba(239, 68, 68, 0.3) !important;
  font-weight: 500 !important;
}

.chip-restrictions:hover {
  background: linear-gradient(135deg, #fecaca 0%, #fca5a5 100%) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4) !important;
}

/* Chip Keywords - کلیدواژه‌ها (بنفش تیره) */
.chip-keywords {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%) !important;
  color: #3730a3 !important;
  border: 1px solid rgba(139, 92, 246, 0.3) !important;
  font-weight: 500 !important;
}

.chip-keywords:hover {
  background: linear-gradient(135deg, #c7d2fe 0%, #a5b4fc 100%) !important;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4) !important;
}

/* Chip CTA - فراخوان (بنفش روشن) */
.chip-cta {
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%) !important;
  color: #6b21a8 !important;
  border: 1px solid rgba(168, 85, 247, 0.3) !important;
  font-weight: 500 !important;
}

.chip-cta:hover {
  background: linear-gradient(135deg, #e9d5ff 0%, #d8b4fe 100%) !important;
  box-shadow: 0 4px 12px rgba(168, 85, 247, 0.4) !important;
}

/* Chip Logic - منطق (نارنجی تیره) */
.chip-logic {
  background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%) !important;
  color: #9a3412 !important;
  border: 1px solid rgba(249, 115, 22, 0.3) !important;
  font-weight: 500 !important;
}

.chip-logic:hover {
  background: linear-gradient(135deg, #fdba74 0%, #fb923c 100%) !important;
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.4) !important;
}

/* Chip Quality - کیفیت (آبی) */
.chip-quality {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%) !important;
  color: #1e40af !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  font-weight: 500 !important;
}

.chip-quality:hover {
  background: linear-gradient(135deg, #bfdbfe 0%, #93c5fd 100%) !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4) !important;
}

/* Chip Emotion - احساسی (صورتی) */
.chip-emotion {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%) !important;
  color: #be185d !important;
  border: 1px solid rgba(236, 72, 153, 0.3) !important;
  font-weight: 500 !important;
}

.chip-emotion:hover {
  background: linear-gradient(135deg, #fbcfe8 0%, #f9a8d4 100%) !important;
  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.4) !important;
}

/* Chip Brand - برند (قرمز تیره) */
.chip-brand {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%) !important;
  color: #991b1b !important;
  border: 1px solid rgba(220, 38, 38, 0.3) !important;
  font-weight: 500 !important;
}

.chip-brand:hover {
  background: linear-gradient(135deg, #fecaca 0%, #fca5a5 100%) !important;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4) !important;
}

/* Chip Repeat - تکرار (لیمویی) */
.chip-repeat {
  background: linear-gradient(135deg, #ecfccb 0%, #d9f99d 100%) !important;
  color: #4d7c0f !important;
  border: 1px solid rgba(132, 204, 22, 0.3) !important;
  font-weight: 500 !important;
}

.chip-repeat:hover {
  background: linear-gradient(135deg, #d9f99d 0%, #bef264 100%) !important;
  box-shadow: 0 4px 12px rgba(132, 204, 22, 0.4) !important;
}

/* Chip Additional - تکمیلی (خاکستری) */
.chip-additional {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%) !important;
  color: #374151 !important;
  border: 1px solid rgba(107, 114, 128, 0.3) !important;
  font-weight: 500 !important;
}

.chip-additional:hover {
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%) !important;
  box-shadow: 0 4px 12px rgba(107, 114, 128, 0.4) !important;
}

/* ==================== Chip Base Styles ==================== */
::v-deep .v-chip {
  height: 36px !important;
  font-size: 0.9rem !important;
  font-weight: 500;
  border-radius: 20px !important;
  margin: 6px 8px 6px 0 !important;
  padding: 0 16px !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  cursor: pointer;
}

::v-deep .v-chip:hover {
  transform: translateY(-2px);
}

::v-deep .v-chip .v-chip__close {
  transition: all 0.2s ease;
}

::v-deep .v-chip .v-chip__close:hover {
  transform: scale(1.2);
}

/* ==================== Utility Classes ==================== */
.btn-w {
  width: 100% !important;
}

/* ==================== Responsive Adjustments ==================== */
@media (max-width: 768px) {
  ::v-deep .v-expansion-panel-header {
    padding: 14px 16px !important;
    min-height: 56px !important;
  }

  ::v-deep .v-expansion-panel-header .text-h6 {
    font-size: 1rem !important;
  }

  ::v-deep .v-chip {
    font-size: 0.85rem !important;
    height: 32px !important;
    padding: 0 12px !important;
  }
}
.progress-bar-container {
  position: relative;
  width: 100%;
}

::v-deep .rainbow-progress .v-progress-linear__determinate {
  background: v-bind(progressBarBackground) !important;
  transition: all 0.3s ease;
}

::v-deep .rainbow-progress .v-progress-linear__background {
  background: #e5e7eb !important;
}
.section-skipped {
  opacity: 0.6;
}

::v-deep .section-skipped .v-expansion-panel-header {
  background-color: #f5f5f5 !important;
}
.dcolumn {
  display: flex;
  flex-direction: column;
}
</style>
